"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrencySymbol = exports.getNumberFormatByOldFormat = exports.getCurrentCellDotNum = exports.modifyFormat = exports.decreaseDecimalFormat = exports.increaseDecimalFormat = exports.getNumberFormatByFormatCode = exports.getCellNumberFormatType = exports.format2TypeMapping = exports.txSheetToMsoFormatMapping = exports.isDateCell = exports.isFractionFormat = exports.isTextCell = exports.isGeneralCell2 = exports.isGeneralCell = exports.isDateTimeCell = exports.clearQuotationMask = exports.isBuildInSpecialFormat = exports.getFormatType = exports.getFormatCodeByNumberFormat = exports.getNumberFormatNameByType = exports.getDefaultNumberFormat = exports.getColorByFormat = exports.isColorFormat = exports.checkNumericValue = exports.write_num = exports.write_date = exports.general_fmt = exports.parse_date_code = void 0;
var Common_1 = require("./Common");
var Constant_1 = require("./Constant");
var decimal_js_1 = __importDefault(require("decimal.js"));
var NumberFormatFactory_1 = __importDefault(require("../model/NumberFormatFactory"));
var NumberFormatType_1 = require("../model/NumberFormatType");
var FormatCache_1 = __importDefault(require("../model/FormatCache"));
function frac(x, D, mixed) {
    var sgn = x < 0 ? -1 : 1;
    var B = x * sgn;
    var P_2 = 0;
    var P_1 = 1;
    var P = 0;
    var Q_2 = 1;
    var Q_1 = 0;
    var Q = 0;
    var A = Math.floor(B);
    while (Q_1 < D) {
        A = Math.floor(B);
        P = A * P_1 + P_2;
        Q = A * Q_1 + Q_2;
        if (B - A < 0.00000005)
            break;
        B = 1 / (B - A);
        P_2 = P_1;
        P_1 = P;
        Q_2 = Q_1;
        Q_1 = Q;
    }
    if (Q > D) {
        if (Q_1 > D) {
            Q = Q_2;
            P = P_2;
        }
        else {
            Q = Q_1;
            P = P_1;
        }
    }
    if (!mixed)
        return [0, sgn * P, Q];
    var q = Math.floor((sgn * P) / Q);
    return [Common_1.getRealNumValueStr("" + q), sgn * P - q * Q, Q]; // 整数部分要完全展开 不能按科学计数展示
}
/**
 * 将日期数值解析为具体的年、月、日、时、分、秒
 * @param val 输入值
 * @param options 可选参数
 * @param specialStartTime 是否以 1900 年 1 月 为参考点
 */
function parse_date_code(val, options, specialStartTime) {
    // excel 支持的最大时间天数为 2958466
    if (val >= 2958466 || val < 0) {
        return null;
    }
    // 取整数部分
    var date = val | 0;
    var time = Math.floor(24 * 3600 * (val - date));
    var week = 0;
    var finalDate = [];
    var output = {
        D: date,
        T: time,
        u: 24 * 3600 * (val - date) - time,
        y: 0,
        m: 0,
        d: 0,
        H: 0,
        M: 0,
        S: 0,
        q: 0,
    };
    // 秒以下的时间太小忽略
    if (Math.abs(output.u) < 1e-6) {
        output.u = 0;
    }
    // 以1904年作为相对起始时间需要加上4年的天数
    if (options === null || options === void 0 ? void 0 : options.date1904) {
        date += 1462;
    }
    if (output.u >= 0.95) {
        output.u = 0;
        time += 1;
        if (time === 24 * 3600) { // 由于加一秒后刚好满一天, 因此进位
            output.T = time = 0;
            date += 1;
            output.D += 1;
        }
    }
    if (date === 60) {
        // 对齐 excel, 有 1900/2/29 这一天
        // finalDate = specialStartTime ? [1317, 10, 29] : [1900, 2, 29];
        // 产品决策不对齐了, 因为存在大量历史数据
        // 由导入导出后台进行兼容
        finalDate = specialStartTime ? [1317, 10, 29] : [1900, 3, 1];
        week = 4;
    }
    else if (date === 0) {
        finalDate = specialStartTime ? [1317, 8, 29] : [1900, 1, 0];
        week = 6;
    }
    else {
        /**
         * execl 有 1900/2/29(60) 这一天, date 大于 60 时, 算了这一天
         * 在 web 日期系统上不存在这一天, 所以用 web API 计算日期时, date 数值需要减 1
         */
        // const realDate = date > 60 ? date - 1: date;
        // 产品决策不对齐了
        var realDate = date;
        /* 1 = Jan 1 1900 in Gregorian */
        var startDate = new Date(1900, 0, 1);
        startDate.setDate(realDate);
        finalDate = [startDate.getFullYear(), startDate.getMonth() + 1, startDate.getDate()];
        week = startDate.getDay();
        /**
         * excel 1900/2/29 占用的这一天, 也占用了那个星期三
         * 所以这一天之前的星期几, 在 web 日期系统中计算出来, 星期几也要减1天
         */
        if (date < 60) {
            week = (week + 6) % 7;
        }
        if (specialStartTime) {
            week = 0;
        }
    }
    // 年、月、日
    output.y = finalDate[0];
    output.m = finalDate[1];
    output.d = finalDate[2];
    // 秒
    output.S = time % 60;
    // 分
    time = Math.floor(time / 60);
    output.M = time % 60;
    // 时
    time = Math.floor(time / 60);
    output.H = time;
    // 星期
    output.q = week;
    return output;
}
exports.parse_date_code = parse_date_code;
function general_fmt_int(v) {
    return v.toString(10);
}
var general_fmt_num = (function make_general_fmt_num() {
    var gnr1 = /\.(\d*[1-9])0+$/;
    var gnr2 = /\.0*$/;
    var gnr4 = /(\.\d*[1-9])(0+)([Ee])/;
    var gnr5 = /\.0*[Ee]/;
    var gnr6 = /(E[+-])(\d)$/;
    function gfn2(v) {
        var w = v < 0 ? 12 : 11;
        var o = gfn5(v.toFixed(12));
        if (o.length <= w)
            return o;
        o = v.toPrecision(10);
        if (o.length <= w)
            return o;
        return v.toExponential(5);
    }
    function gfn3(v) {
        var o = v.toFixed(11).replace(gnr1, '.$1');
        if (o.length > (v < 0 ? 12 : 11))
            o = v.toPrecision(6);
        return o;
    }
    function gfn4(o) {
        for (var i = 0; i != o.length; ++i) {
            if ((o.charCodeAt(i) | 0x20) === 101) {
                return o.replace(gnr4, '$1$3').replace(gnr5, 'E').replace('e', 'E').replace(gnr6, '$10$2');
            }
        }
        return o;
    }
    function gfn5(o) {
        return o.indexOf('.') > -1 ? o.replace(gnr2, '').replace(gnr1, '.$1') : o;
    }
    return function general_fmt_num(v) {
        var V = Math.floor(Math.log(Math.abs(v)) * Math.LOG10E);
        var o;
        if (V >= -4 && V <= -1)
            o = v.toPrecision(10 + V);
        else if (Math.abs(V) <= 9)
            o = gfn2(v);
        else if (V === 10)
            o = v.toFixed(10).substr(0, 12);
        else
            o = gfn3(v);
        return gfn5(gfn4(o));
    };
})();
/** 单元格格式为“常规General”格式处理 */
function general_fmt(v) {
    if (Common_1.isNumeric(v) && !/\n/.test(v)) {
        var num = Number(v);
        if (num === Infinity || num === -Infinity) {
            return v;
        }
        return (num | 0) === num ? general_fmt_int(num) : general_fmt_num(num);
    }
    return v;
    // switch(typeof v) {
    //     case 'string': return v;
    //     case 'boolean': return v ? "TRUE" : "FALSE";
    //     case 'number': return (v|0) === v ? general_fmt_int(v) : general_fmt_num(v);
    //     // case 'number': return v.toString();
    //     case 'undefined': return "";
    //     case 'object':
    //         if(v == null) return "";
    //         return v.toString();
    // }
    throw new Error("unsupported value in General format: " + v);
}
exports.general_fmt = general_fmt;
// 输出日期格式
function write_date(type, fmt, val, ss0) {
    var o = '';
    var ss = 0;
    var tt = 0;
    var y = val.y;
    var out;
    var outl = 0;
    switch (type) {
        case 97 /** a 4个a是星期x 3个a是周x */:
            if (fmt === 'aaaa') {
                // 星期x
                return Constant_1.DAYS[val.q][2];
            }
            if (fmt === 'aaa') {
                // 周x
                return Constant_1.DAYS[val.q][3];
            }
            break;
        case 98 /* 'b' buddhist year */:
            y = val.y + 543;
        /* falls through */
        case 121 /* 'y' year */:
            switch (fmt.length) {
                case 1:
                case 2:
                    out = y % 100;
                    outl = 2;
                    break;
                default:
                    out = y % 10000;
                    outl = 4;
                    break;
            }
            break;
        case 109 /* 'm' month */:
            switch (fmt.length) {
                case 1:
                case 2:
                    out = val.m;
                    outl = fmt.length;
                    break;
                case 3:
                    return Constant_1.MONTHS[val.m - 1][1];
                case 5:
                    return Constant_1.MONTHS[val.m - 1][0];
                default:
                    return Constant_1.MONTHS[val.m - 1][2];
            }
            break;
        case 100 /* 'd' day */:
            switch (fmt.length) {
                case 1:
                case 2:
                    out = val.d;
                    outl = fmt.length;
                    break;
                case 3:
                    return Constant_1.DAYS[val.q][0];
                default:
                    return Constant_1.DAYS[val.q][1];
            }
            break;
        case 104 /* 'h' 12-hour */:
            switch (fmt.length) {
                case 1:
                case 2:
                    out = 1 + ((val.H + 11) % 12);
                    outl = fmt.length;
                    break;
                default:
                    throw "bad hour format: " + fmt;
            }
            break;
        case 72 /* 'H' 24-hour */:
            switch (fmt.length) {
                case 1:
                case 2:
                    out = val.H;
                    outl = fmt.length;
                    break;
                default:
                    throw "bad hour format: " + fmt;
            }
            break;
        case 77 /* 'M' minutes */:
            switch (fmt.length) {
                case 1:
                case 2:
                    out = val.M;
                    outl = fmt.length;
                    break;
                default:
                    throw "bad minute format: " + fmt;
            }
            break;
        case 115 /* 's' seconds */:
            if (fmt != 's' && fmt != 'ss' && fmt != '.0' && fmt != '.00' && fmt != '.000')
                throw "bad second format: " + fmt;
            if (val.u === 0 && (fmt == 's' || fmt == 'ss'))
                return Common_1.pad0(val.S, fmt.length);
            if (!ss0)
                ss0 = 0;
            if (ss0 >= 2)
                tt = ss0 === 3 ? 1000 : 100;
            else
                tt = ss0 === 1 ? 10 : 1;
            ss = Math.round(tt * (val.S + val.u));
            if (ss >= 60 * tt)
                ss = 0;
            if (fmt === 's')
                return ss === 0 ? '0' : "" + ss / tt;
            o = Common_1.pad0(ss, 2 + ss0);
            if (fmt === 'ss')
                return o.substr(0, 2);
            return "." + o.substr(2, fmt.length - 1);
        case 90 /* 'Z' absolute time */:
            switch (fmt) {
                case '[h]':
                case '[hh]':
                    out = val.D * 24 + val.H;
                    break;
                case '[m]':
                case '[mm]':
                    out = (val.D * 24 + val.H) * 60 + val.M;
                    break;
                case '[s]':
                case '[ss]':
                    out = ((val.D * 24 + val.H) * 60 + val.M) * 60 + Math.round(val.S + val.u);
                    break;
                default:
                    throw "bad abstime format: " + fmt;
            }
            outl = fmt.length === 3 ? 1 : 2;
            break;
        case 101 /* 'e' era */:
            out = y;
            outl = 1;
    }
    if (outl > 0)
        return Common_1.pad0(out, outl);
    return '';
}
exports.write_date = write_date;
/* jshint +W086 */
function commaify(s) {
    var w = 3;
    if (s.length <= w)
        return s;
    var j = s.length % w;
    var o = s.substr(0, j);
    for (; j != s.length; j += w)
        o += (o.length > 0 ? ',' : '') + s.substr(j, w);
    return o;
}
function commaifyNum(s) {
    var w = 3;
    var dotIndex = s.indexOf('.');
    if (dotIndex !== -1) {
        var intStr = s.substr(0, dotIndex);
        return commaify(intStr) + s.substr(dotIndex);
    }
    return commaify(s);
}
function reverseStr(str) {
    return str ? str.split('').reverse().join('') : '';
}
function flr(val) {
    if (val < 2147483647 && val > -2147483648)
        return "" + (val >= 0 ? val | 0 : (val - 1) | 0);
    return "" + Math.floor(val);
}
function commaifyIntNum(val, intFmt) {
    var numStr = reverseStr(flr(val));
    var fmt = reverseStr(intFmt).replace(/,/g, '');
    var nIndex = 0;
    var fIndex = 0;
    var outStr = '';
    var isNeedComaify = intFmt.indexOf(',') !== -1;
    for (; nIndex < numStr.length && fIndex < fmt.length;) {
        if (fmt[fIndex] === ',') {
            outStr += ',';
            fIndex++;
            continue;
        }
        outStr += numStr[nIndex];
        nIndex++;
        fIndex++;
    }
    if (nIndex < numStr.length) {
        // 数字没用完，继续展示完成
        if (isNeedComaify) {
            // 需要加上千位分隔符
            var initIndex = Math.max(0, outStr.lastIndexOf(','));
            var step = outStr.length - initIndex;
            for (; nIndex < numStr.length; nIndex++) {
                if (step % 3 === 0) {
                    outStr += ',';
                }
                outStr += numStr[nIndex];
                step++;
            }
        }
        else {
            outStr += numStr.substr(nIndex);
        }
    }
    else if (fIndex < fmt.length) {
        // 格式没用完 那就要把0和？继续用完
        if (isNeedComaify) {
            // 需要加上千位分隔符
            var initIndex = Math.max(0, outStr.lastIndexOf(','));
            var step = outStr.length - initIndex;
            for (; fIndex < fmt.length; fIndex++) {
                if (step % 3 === 0) {
                    outStr += ',';
                }
                outStr += fmt[fIndex];
                step++;
            }
        }
        else {
            outStr += fmt.substr(fIndex);
        }
        outStr = outStr.replace(/#/g, '').replace(/\?/g, ' ');
    }
    outStr = reverseStr(outStr); // 翻转
    outStr = outStr.replace(/(\ +),/g, '$1');
    return outStr;
}
/**
 * 浮点数四舍五入
 * @param {*} numStr 需要处理的数字
 * @param {*} floatFmt 浮点部分的格式串
 */
function fixFloatNum(numStr, floatFmt) {
    function padFloatFmt(floatFmt) {
        var str = '';
        floatFmt = floatFmt || '';
        for (var i = 0; i < floatFmt.length; i++) {
            switch (floatFmt.charAt(i)) {
                case '0':
                    str += '0';
                    break;
                case '?':
                    str += ' ';
                    break;
                case '#': // 不填充任何内容
                    break;
            }
        }
        return str;
    }
    var d = (floatFmt && floatFmt.length) || 0;
    if (typeof numStr === 'number') {
        numStr = numStr.toString();
    }
    if (numStr.toUpperCase().indexOf('E') !== -1) {
        numStr = Common_1.getRealNumValueStr(numStr);
    }
    var originLen = numStr.length;
    var dotIndex = numStr.indexOf('.');
    if (dotIndex === -1) {
        numStr = numStr + "." + padFloatFmt(floatFmt);
    }
    else if (originLen - dotIndex - 1 <= d) {
        numStr = numStr + padFloatFmt(floatFmt.substr(originLen - dotIndex - 1));
    }
    else if (originLen - dotIndex - 1 > d) {
        // 小数位比要保留的多了2位或者2位以上  那就直接截取掉
        numStr = numStr.substr(0, dotIndex + 1 + d + 1);
        originLen = numStr.length; // 更新计算用的originLen
        var lastChar = numStr.substr(-1);
        var iLastNum = parseInt(lastChar);
        if (iLastNum >= 5) {
            var flag = true; // 是否需要进位
            var index = originLen - 2;
            var out = '';
            while (index >= 0) {
                var c = numStr.charAt(index);
                if (c === '.') {
                    out = c + out;
                }
                else if (flag) {
                    if (parseInt(c) === 9) {
                        // 当前为是9  那就继续进位
                        out = "0" + out;
                        flag = true;
                    }
                    else {
                        // 当前为小于9  那就加一即可
                        out = parseInt(c) + 1 + out;
                        flag = false;
                    }
                }
                else {
                    // 直接赋值拼接
                    out = c + out;
                    flag = false;
                }
                index--;
            }
            if (flag) {
                out = "1" + out;
            }
            if (d === 0 && numStr.indexOf('.') === -1 && out.length === originLen) {
                // 这个场景下numStr都是小数部分，进位的部分要丢掉
                out = out.substr(1);
            }
            numStr = out;
            // 需要进位
            // numStr = (parseFloat(numStr.substr(0, numStr.length-1)) + 1/Math.pow(10,d)).toString();
            if (numStr.length < originLen - 1) {
                // 前导0要补齐
                numStr = Common_1.fill('0', originLen - numStr.length - 1) + numStr;
            }
        }
        else {
            numStr = numStr.substr(0, numStr.length - 1);
        }
    }
    return numStr.toString();
}
/**
 * 将传入字符串转换为数字, 本身为数字则不需要改动 (主要解决 typescript 对入参格式的要求问题)
 * @param val 需要处理的数字或字符串
 */
function getNumericalVal(val) {
    // 对字符串使用 parseFloat
    return typeof val === 'number' ? val : parseFloat(val);
}
/**
 * 为数字或字符串负值取反操作
 * @param val 需要处理的数字或者字符串
 */
function positiveNumberOrString(val) {
    // 当 val 为 string 时, 由于本身是负值所以直接去掉首位负号
    return typeof val === 'number' ? -val : val.slice(1);
}
/**
 * 判断数字或者字符串精度是否超过 16
 * @param val 需要处理的数字或者字符串
 */
function isPrecisionBiggerThan16(val) {
    if (typeof val === 'number') {
        // 如果本来就是数字的话, 自然不会超 16 位精度, 那就不需要判断了
        return false;
    }
    if (!val) {
        return false;
    }
    var dot = val.indexOf('.');
    if (dot !== -1) {
        // 将小数转换为整数, 然后再统一算精度
        val = val.substr(0, dot) + val.substr(dot + 1, val.length);
    }
    val = val.replace(/[+-]/, ''); // 处理正负号
    val = val.toUpperCase();
    var exp = val.indexOf('E');
    if (exp !== -1) {
        // 将科学计数 E 后面的部分去掉
        val = val.substr(0, exp);
    }
    var regResult = val.match(/0*([1-9]([0-9]*[1-9])?)0*$/);
    return !!(regResult && regResult[1].length > 16);
}
// 数字相关格式的输出
exports.write_num = (function make_write_num() {
    var pct1 = /%/g;
    function write_num_pct(type, fmt, val) {
        var sfmt = fmt.replace(pct1, '');
        var mul = fmt.length - sfmt.length;
        return exports.write_num(type, sfmt, percentNum(val.toString(), mul * 2)) + Common_1.fill('%', mul);
    }
    /**
     * 对数值进行百分比换算 如0.955 length=2的情况下  结果是95.5
     * @param val 待处理数字字符串
     * @param rightShiftLength 右移位数, 右移一位位相当于x10, 右移两位相当于x100
     */
    function percentNum(val, rightShiftLength) {
        if (val.indexOf('e') !== -1 || val.indexOf('E') !== -1) {
            // 千分位表示先转换成普通的数值表示
            val = Common_1.getRealNumValueStr(val);
        }
        var dotIndex = val.indexOf('.');
        var result;
        if (dotIndex !== -1) {
            var intStr = val.slice(0, dotIndex);
            var floatStr = val.slice(dotIndex + 1);
            result = intStr;
            // 加上整数部分
            result += floatStr.substr(0, rightShiftLength);
            // 去除前导 0 
            result = result.replace(/^([+-])?(0*)([\d]+)/, '$1$3');
            if (floatStr.length > rightShiftLength) {
                // 进位完成之后还有剩余的小数位 全部补齐
                result += '.';
                result += floatStr.substr(rightShiftLength);
            }
            else {
                result += Common_1.fill('0', rightShiftLength - floatStr.length);
            }
        }
        else {
            result = val + Common_1.fill('0', rightShiftLength);
        }
        return result;
    }
    function write_num_cm(type, fmt, val) {
        var idx = fmt.length - 1;
        while (fmt.charCodeAt(idx - 1) === 44)
            --idx;
        return exports.write_num(type, fmt.substr(0, idx), val / Math.pow(10, 3 * (fmt.length - idx)));
    }
    function write_num_exp(fmt, val) {
        if (!isNaN(val) && val < 0) {
            return "-" + write_num_exp(fmt, -val);
        }
        var o;
        fmt = fmt.toUpperCase();
        var idx = fmt.indexOf('E') - fmt.indexOf('.') - 1;
        var matchResult = fmt.match(/^(#+0).0E\+0?$/);
        if (matchResult) {
            if (val == 0)
                return Common_1.fill('0', matchResult[1].length) + ".0E+0";
            if (val < 0)
                return "-" + write_num_exp(fmt, -val);
            var period_1 = fmt.indexOf('.');
            if (period_1 === -1)
                period_1 = fmt.indexOf('E');
            var ee_1 = Math.floor(Math.log(val) * Math.LOG10E) % period_1;
            if (ee_1 < 0)
                ee_1 += period_1;
            o = (val / Math.pow(10, ee_1)).toPrecision(idx + 1 + ((period_1 + ee_1) % period_1));
            if (o.indexOf('e') === -1) {
                var fakee = Math.floor(Math.log(val) * Math.LOG10E);
                if (o.indexOf('.') === -1)
                    o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length + ee_1);
                else
                    o += "E+" + (fakee - ee_1);
                while (o.substr(0, 2) === '0.') {
                    o = o.charAt(0) + o.substr(2, period_1) + "." + o.substr(2 + period_1);
                    o = o.replace(/^0+([1-9])/, '$1').replace(/^0+\./, '0.');
                }
                o = o.replace(/\+-/, '-');
            }
            o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function ($$, $1, $2, $3) { return $1 + $2 + $3.substr(0, (period_1 + ee_1) % period_1) + "." + $3.substr(ee_1) + "E"; });
        }
        else if (fmt.indexOf('.') !== -1) {
            var expResult = new decimal_js_1.default(val).toExponential(idx + 2);
            var eIndex = expResult.indexOf('e') || expResult.indexOf('E');
            var result = fixFloatNum(expResult.substr(0, eIndex), fmt.substr(fmt.indexOf('.') + 1, idx));
            var dotIndex = result.indexOf('.');
            if (dotIndex > 1) {
                // 出现了例如 10.00这样的数字  科学计数法只能保留一位整数 所以要特殊处理下
                var eNum = parseInt(expResult.substr(eIndex + 1));
                result = result.charAt(0) + "." + result.substr(1).replace('.', '').substr(0, idx);
                eNum = eNum + (dotIndex - 1);
                var sign = eNum >= 0 ? '+' : '-';
                o = result + "E" + sign + Common_1.pad0(Math.abs(eNum), 2);
            }
            else {
                o = result.toString() + expResult.substr(eIndex);
            }
        }
        else {
            o = val.toExponential(0);
        }
        if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/))
            o = o.substr(0, o.length - 1) + "0" + o.charAt(o.length - 1);
        if (fmt.match(/E\-/) && o.match(/e\+/))
            o = o.replace(/e\+/, 'e');
        return o.replace('e', 'E');
    }
    var frac1 = /# (\?+)(\s*)\/(\s*)(\d+)/;
    function write_num_f1(r, aval, sign) {
        var den = parseInt(r[4], 10);
        var num = new decimal_js_1.default(aval);
        var rr = num.mul(den).round();
        var base = rr.div(den).floor();
        var myn = rr.minus(base.mul(den));
        var myd = den;
        var numStr = myn.toNumber() === 0
            ? Common_1.fill(' ', r[1].length + 1 + r[4].length)
            : Common_1.pad_(myn.toString(), r[1].length) + r[2] + "/" + r[3] + Common_1.pad0(myd.toString(), r[4].length); // 得到分数部分
        if (numStr.trim() === '' && base.toNumber() === 0) {
            // 分数部分为空 并且整数部分为0  那就显示个0
            return sign + "0" + (" " + numStr);
        }
        return sign + (base.toNumber() === 0 ? '' : "" + Common_1.getRealNumValueStr(base.toString())) + " " + numStr;
    }
    function write_num_f2(r, aval, sign) {
        return sign + aval + Common_1.fill(' ', r[1].length + 2 + r[4].length);
    }
    var dec1 = /^#*0*\.([0#?]+)/;
    var closeparen = /\).*[0#]/;
    var phone = /\(###\) ###\\?-####/;
    function hashq(str) {
        var o = '';
        var cc;
        for (var i = 0; i != str.length; ++i) {
            switch ((cc = str.charCodeAt(i))) {
                case 35:
                    break;
                case 63:
                    o += ' ';
                    break;
                case 48:
                    o += '0';
                    break;
                default:
                    o += String.fromCharCode(cc);
            }
        }
        return o;
    }
    function dec(val, floatFmt) {
        var numStr = fixFloatNum(val, floatFmt);
        return numStr.substr(numStr.indexOf('.') + 1);
    }
    function write_num_flt(type, fmt, val) {
        if (type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
            var hasRightParenthesis = /\) */.test(fmt);
            var ffmt = fmt.replace(/\( */, '').replace(/ \)/, '').replace(/\)/, '');
            if (val >= 0)
                return write_num_flt('n', ffmt, val);
            return "(" + write_num_flt('n', ffmt, positiveNumberOrString(val)) + (hasRightParenthesis ? ')' : '');
        }
        if (fmt.charCodeAt(fmt.length - 1) === 44) {
            return write_num_cm(type, fmt, getNumericalVal(val));
        }
        if (fmt.indexOf('%') !== -1) {
            return write_num_pct(type, fmt, getNumericalVal(val));
        }
        if (fmt.indexOf('E') !== -1) {
            return write_num_exp(fmt, getNumericalVal(val));
        }
        if (fmt.charCodeAt(0) === 36) {
            return "$" + write_num_flt(type, fmt.substr(fmt.charAt(1) == ' ' ? 2 : 1), val);
        }
        var o;
        var r;
        var ri;
        var ff;
        var aval;
        if (isPrecisionBiggerThan16(val)) {
            aval = val < 0 ? positiveNumberOrString(val) : val;
        }
        else {
            aval = Math.abs(getNumericalVal(val));
        }
        var sign = val < 0 ? '-' : '';
        if (fmt.match(/^00+$/)) {
            var numStr = Common_1.pad0r(aval, fmt.length);
            numStr = Common_1.getRealNumValueStr(numStr);
            if (/^0+$/.test(numStr)) {
                // 如果全为0  那就当正数处理了 不需要负号了
                return numStr;
            }
            return sign + numStr;
        }
        if (fmt.match(/^[#?]+$/)) {
            o = Common_1.pad0r(val, 0);
            if (o === '0')
                o = '';
            return o.length > fmt.length ? o : hashq(fmt.substr(0, fmt.length - o.length)) + o;
        }
        if ((r = fmt.match(frac1))) {
            return write_num_f1(r, aval, sign);
        }
        if (fmt.match(/^#+0+$/)) {
            return sign + Common_1.pad0r(aval, fmt.length - fmt.indexOf('0'));
        }
        if ((r = fmt.match(dec1))) {
            o =
                sign +
                    fixFloatNum(aval, r[1])
                        .replace(/^([^\.]+)$/, "$1." + hashq(r[1]))
                        .replace(/\.$/, "." + hashq(r[1]))
                        .replace(/\.(\d*)$/, function ($$, $1) { return "." + $1 + Common_1.fill('0', hashq(/* : :( */ r[1]).length - $1.length); });
            if (o.indexOf('e') !== -1 || (o.indexOf('E') !== -1 && parseFloat(o) > 0)) {
                // 科学计数要转换一下 不能按科学计数来
                return Common_1.getRealNumValueStr(o);
            }
            return fmt.indexOf('0.') !== -1 ? o : o.replace(/^0\./, '.');
        }
        fmt = fmt.replace(/^#+([0.])/, '$1');
        if ((r = fmt.match(/^(0*)\.(#*)$/))) {
            return (sign +
                fixFloatNum(aval, r[2])
                    .replace(/\.(\d*[1-9])0*$/, '.$1')
                    .replace(/^(-?\d*)$/, '$1.')
                    .replace(/^0\./, r[1].length ? '0.' : '.'));
        }
        if ((r = fmt.match(/^#{1,3},##0(\.?)$/))) {
            var avalStr = aval.toString();
            if (avalStr.indexOf('e') !== -1 || avalStr.indexOf('E') !== -1) {
                // 科学计数要转换一下 不能按科学计数来，下同（虽然代码很像，但我还是不敢合并起来）
                val = Math.abs(getNumericalVal(val));
                var realNumStr = Common_1.getRealNumValueStr(val);
                // 四舍五入
                var fixedNumberStr = fixFloatNum(realNumStr, '');
                // 若格式串中无小数点则不保存小数点
                if (!r[1]) {
                    fixedNumberStr = fixedNumberStr.substr(0, fixedNumberStr.length - 1);
                }
                return sign + commaify(fixedNumberStr);
            }
            return sign + commaify(Common_1.pad0r(aval, 0));
        }
        if ((r = fmt.match(/^#,##0\.([#0?]*[0?])$/))) {
            var valStr = val.toString();
            if (valStr.indexOf('e') !== -1 || (valStr.indexOf('E') !== -1 && val > 0)) {
                // 科学计数要转换一下 不能按科学计数来
                val = Math.abs(getNumericalVal(val));
                var realNumStr = Common_1.getRealNumValueStr(val);
                return sign + commaifyNum(fixFloatNum(realNumStr, r[1]));
            }
            return val < 0
                ? "-" + write_num_flt(type, fmt, positiveNumberOrString(val))
                : commaifyNum(fixFloatNum(val, r[1]));
        }
        if ((r = fmt.match(/^#,#*,#0/)))
            return write_num_flt(type, fmt.replace(/^#,#*,/, ''), val);
        if ((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/))) {
            o = Common_1._strrev(write_num_flt(type, fmt.replace(/[\\-]/g, ''), val));
            ri = 0;
            return Common_1._strrev(Common_1._strrev(fmt.replace(/\\/g, '')).replace(/[0#]/g, function (x) {
                return ri < o.length ? o.charAt(ri++) : x === '0' ? '0' : '';
            }));
        }
        if (fmt.match(phone)) {
            o = write_num_flt(type, '##########', val);
            return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
        }
        var oa = '';
        if ((r = fmt.match(/^([#0?]+)(\s*)\/(\s*)([#0?]+)/))) {
            ri = Math.min(/* : :String( */ r[4].length, 7);
            ff = frac(getNumericalVal(aval), Math.pow(10, ri) - 1, false);
            o = "" + sign;
            oa = exports.write_num('n', /* : :String( */ r[1] /* : :) */, ff[1]);
            if (oa.charAt(oa.length - 1) == ' ')
                oa = oa.substr(0, oa.length - 1) + "0";
            o += oa + /* : :String( */ r[2] + "/" + r[3];
            oa = Common_1.rpad_(ff[2], ri);
            if (oa.length < r[4].length)
                oa = hashq(r[4].substr(r[4].length - oa.length)) + oa;
            o += oa;
            return o;
        }
        if ((r = fmt.match(/^([#0?]+)(\s*)(\?+)\/(\s*)([#0?]+)/))) {
            ri = Math.min(/* : :String( */ r[5].length, 7);
            ff = frac(getNumericalVal(aval), Math.pow(10, ri) - 1, true);
            o = '';
            oa = exports.write_num('n', /* : :String( */ r[3] /* : :) */, ff[1]) || ''; // 得到分子
            if (oa.trim() !== '0' && oa.trim() !== '') {
                // 分子如果为0  就不要展示分数部分了
                o += r[2] + oa + "/" + r[4];
                oa = Common_1.rpad_(ff[2], ri);
                if (oa.length < r[5].length)
                    oa = hashq(r[5].substr(r[5].length - oa.length)) + oa; // 得到分母
                o += oa;
            }
            else {
                o += Common_1.fill(' ', fmt.length - r[1].length); // 除去整数部分的长度 全部填充空格
            }
            oa = exports.write_num('n', /* : :String( */ r[1] /* : :) */, ff[0]) || ''; // 得到整数
            if (o.trim() === '') {
                // 分数部分为空
                if (oa.trim() === '') {
                    o = "0" + o;
                }
                else {
                    o = oa + o;
                }
            }
            else if (oa.trim() !== '0') {
                // 整数部分为0 并且分数部分为空串的话要显示0  否则不显示整数的0
                o = oa + o;
            }
            o = "" + sign + o;
            return o;
        }
        if ((r = fmt.match(/^# ([#0?]+)(\s*)\/(\s*)([#0?]+)/))) {
            ri = Math.min(Math.max(r[1].length, r[4].length), 7);
            ff = frac(getNumericalVal(aval), Math.pow(10, ri) - 1, true);
            return sign + ((ff[0] !== '0' ? ff[0] : '') || (ff[1] ? '' : '0')) + " " + (ff[1]
                ? Common_1.pad_(ff[1], ri) + r[2] + "/" + r[3] + Common_1.rpad_(ff[2], ri)
                : Common_1.fill(' ', 2 * ri + 1 + r[2].length + r[3].length));
        }
        if ((r = fmt.match(/^[#0?]+$/))) {
            o = Common_1.pad0r(val, 0);
            if (o.indexOf('e') !== -1 || o.indexOf('E') !== -1) {
                o = Common_1.getRealNumValueStr(o);
            }
            if (fmt.length <= o.length)
                return o;
            return hashq(fmt.substr(0, fmt.length - o.length)) + o;
        }
        if ((r = fmt.match(/^([#0?]+)\.([#0?]+)$/))) {
            o = "" + getNumericalVal(val)
                .toFixed(Math.min(r[2].length, 10))
                .replace(/([^0])0+$/, '$1');
            ri = o.indexOf('.');
            var lres = fmt.indexOf('.') - ri;
            var rres = fmt.length - o.length - lres;
            return hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
        }
        if ((r = fmt.match(/^00,000\.([#0?]*0)$/))) {
            ri = dec(val, r[1]);
            return val < 0
                ? "-" + write_num_flt(type, fmt, positiveNumberOrString(val))
                : commaify(flr(getNumericalVal(val)))
                    .replace(/^\d,\d{3}$/, '0$&')
                    .replace(/^\d*$/, function ($$) { return "00," + ($$.length < 3 ? Common_1.pad0(0, 3 - $$.length) : '') + $$; }) + "." + Common_1.pad0(ri, r[1].length);
        }
        if ((r = fmt.match(/^(([0#?]{1,3},)?([0#?]{3},)*([0#?]{3})?)(\.|\.([0#?]+))?$/))) {
            // 只要符合0,##?,0#0,###,000.0#?这种的都算
            if (val < 0) {
                return "-" + write_num_flt(type, fmt, positiveNumberOrString(val));
            }
            var intValue = commaifyIntNum(getNumericalVal(val), r[1]);
            if (intValue.indexOf(',') === 0) {
                intValue = intValue.slice(1);
            }
            if (r[6]) {
                return intValue + fixFloatNum(val, r[6]).replace(/(\d*)\./, '.');
            }
            return intValue;
        }
        switch (fmt) {
            case '###,##0.00':
                return write_num_flt(type, '#,##0.00', val);
            case '###,###':
            case '##,###':
            case '#,###':
                var x = commaify(Common_1.pad0r(aval, 0));
                return x !== '0' ? sign + x : '';
            case '###,###.00':
                return write_num_flt(type, '###,##0.00', val).replace(/^0\./, '.');
            case '#,###.00':
                return write_num_flt(type, '#,##0.00', val).replace(/^0\./, '.');
            default:
        }
        return "" + val;
        // throw new Error("unsupported format |" + fmt + "|");
    }
    function write_num_cm2(type, fmt, val) {
        var idx = fmt.length - 1;
        while (fmt.charCodeAt(idx - 1) === 44)
            --idx;
        return exports.write_num(type, fmt.substr(0, idx), val / Math.pow(10, 3 * (fmt.length - idx)));
    }
    function write_num_pct2(type, fmt, val) {
        var sfmt = fmt.replace(pct1, '');
        var mul = fmt.length - sfmt.length;
        return exports.write_num(type, sfmt, val * Math.pow(10, 2 * mul)) + Common_1.fill('%', mul);
    }
    function write_num_exp2(fmt, val) {
        var o;
        var idx = fmt.indexOf('E') - fmt.indexOf('.') - 1;
        var matchResult = fmt.match(/^(#+0).0E\+0?$/);
        if (matchResult) {
            if (val == 0)
                return Common_1.fill('0', matchResult[1].length) + ".0E+0";
            if (val < 0)
                return "-" + write_num_exp2(fmt, -val);
            var period_2 = fmt.indexOf('.');
            if (period_2 === -1)
                period_2 = fmt.indexOf('E');
            var ee_2 = Math.floor(Math.log(val) * Math.LOG10E) % period_2;
            if (ee_2 < 0)
                ee_2 += period_2;
            o = (val / Math.pow(10, ee_2)).toPrecision(idx + 1 + ((period_2 + ee_2) % period_2));
            if (!o.match(/[Ee]/)) {
                var fakee = Math.floor(Math.log(val) * Math.LOG10E);
                if (o.indexOf('.') === -1)
                    o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length + ee_2);
                else
                    o += "E+" + (fakee - ee_2);
                o = o.replace(/\+-/, '-');
            }
            o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function ($$, $1, $2, $3) { return $1 + $2 + $3.substr(0, (period_2 + ee_2) % period_2) + "." + $3.substr(ee_2) + "E"; });
        }
        else if (fmt.indexOf('.') === -1) {
            o = val.toExponential(0);
        }
        else {
            o = Common_1.extToExponential(val, idx);
        }
        if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/))
            o = o.substr(0, o.length - 1) + "0" + o.charAt(o.length - 1);
        if (fmt.match(/E\-/) && o.match(/e\+/))
            o = o.replace(/e\+/, 'e');
        return o.replace('e', 'E');
    }
    function write_num_int(type, fmt, val) {
        if (type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
            var hasRightParenthesis = /\) */.test(fmt);
            var ffmt = fmt.replace(/\( */, '').replace(/ \)/, '').replace(/\)/, '');
            if (val >= 0)
                return write_num_int('n', ffmt, val);
            return "(" + write_num_int('n', ffmt, -val) + (hasRightParenthesis ? ')' : '');
        }
        if (fmt.charCodeAt(fmt.length - 1) === 44)
            return write_num_cm2(type, fmt, val);
        if (fmt.indexOf('%') !== -1)
            return write_num_pct2(type, fmt, val);
        if (fmt.indexOf('E') !== -1)
            return write_num_exp2(fmt, val);
        if (fmt.charCodeAt(0) === 36)
            return "$" + write_num_int(type, fmt.substr(fmt.charAt(1) == ' ' ? 2 : 1), val);
        var o;
        var formatMatch;
        /**
         * 从分数的 case, 表示(分子或分母)有效数字的位数
         */
        var significanCount;
        /**
         * 从分数的 case, 表示分数的
         */
        var fractionParts;
        var aval = Math.abs(val);
        var sign = val < 0 ? '-' : '';
        if (fmt.match(/^00+$/)) {
            var numStr = Common_1.pad0(aval, fmt.length);
            numStr = Common_1.getRealNumValueStr(numStr);
            if (/^0+$/.test(numStr)) {
                // 如果全为0  那就当正数处理了 不需要负号了
                return numStr;
            }
            return sign + numStr;
        }
        if (fmt.match(/^[#?]+$/)) {
            o = "" + val;
            if (o === '0')
                o = '';
            return o.length > fmt.length ? o : hashq(fmt.substr(0, fmt.length - o.length)) + o;
        }
        if ((formatMatch = fmt.match(frac1)))
            return write_num_f2(formatMatch, aval, sign);
        if (fmt.match(/^#+0+$/))
            return sign + Common_1.pad0(aval, fmt.length - fmt.indexOf('0'));
        if ((formatMatch = fmt.match(dec1))) {
            /* :: if(!Array.isArray(r)) throw new Error("unreachable"); */
            o = ("" + val).replace(/^([^\.]+)$/, "$1." + hashq(formatMatch[1])).replace(/\.$/, "." + hashq(formatMatch[1]));
            o = o.replace(/\.(\d*)$/, function ($$, $1) {
                /* :: if(!Array.isArray(r)) throw new Error("unreachable"); */
                return "." + $1 + Common_1.fill('0', hashq(formatMatch[1]).length - $1.length);
            });
            return fmt.indexOf('0.') !== -1 ? o : o.replace(/^0\./, '.');
        }
        fmt = fmt.replace(/^#+([0.])/, '$1');
        if ((formatMatch = fmt.match(/^(0*)\.(#*)$/))) {
            return (sign +
                ("" + aval)
                    .replace(/\.(\d*[1-9])0*$/, '.$1')
                    .replace(/^(-?\d*)$/, '$1.')
                    .replace(/^0\./, formatMatch[1].length ? '0.' : '.'));
        }
        if ((formatMatch = fmt.match(/^#{1,3},##0(\.?)$/)))
            return sign + commaify("" + aval);
        if ((formatMatch = fmt.match(/^#,##0\.([#0]*0)$/))) {
            return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify("" + val) + "." + Common_1.fill('0', formatMatch[1].length);
        }
        if ((formatMatch = fmt.match(/^#,#*,#0/)))
            return write_num_int(type, fmt.replace(/^#,#*,/, ''), val);
        if ((formatMatch = fmt.match(/^([0#]+)(\\?-([0#]+))+$/))) {
            o = Common_1._strrev(write_num_int(type, fmt.replace(/[\\-]/g, ''), val));
            significanCount = 0;
            return Common_1._strrev(Common_1._strrev(fmt.replace(/\\/g, '')).replace(/[0#]/g, function (x) {
                return significanCount < o.length ? o.charAt(significanCount++) : x === '0' ? '0' : '';
            }));
        }
        if (fmt.match(phone)) {
            o = write_num_int(type, '##########', val);
            return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
        }
        var oa = '';
        if ((formatMatch = fmt.match(/^([#0?]+)(\s*)\/(\s*)([#0?]+)/))) {
            significanCount = Math.min(/* : :String( */ formatMatch[4].length, 7);
            fractionParts = frac(aval, Math.pow(10, significanCount) - 1, false);
            o = "" + sign;
            oa = exports.write_num('n', /* : :String( */ formatMatch[1] /* : :) */, fractionParts[1]);
            if (oa.charAt(oa.length - 1) == ' ')
                oa = oa.substr(0, oa.length - 1) + "0";
            o += oa + /* : :String( */ formatMatch[2] + "/" + formatMatch[3];
            oa = Common_1.rpad_(fractionParts[2], significanCount);
            if (oa.length < formatMatch[4].length)
                oa = hashq(formatMatch[4].substr(formatMatch[4].length - oa.length)) + oa;
            o += oa;
            return o;
        }
        // 整数命中分数的 format, 比如 '# ?/?'
        if ((formatMatch = fmt.match(/^# ([#0?]+)(\s*)\/(\s*)([#0?]+)/))) {
            significanCount = Math.min(Math.max(formatMatch[1].length, formatMatch[4].length), 7);
            fractionParts = frac(aval, Math.pow(10, significanCount) - 1, true);
            // 整数部分
            var wholeNumberPart = "" + (sign + ((fractionParts[0] !== '0' ? fractionParts[0] : '') || (fractionParts[1] ? '' : '0')));
            // 分数部分
            var fractionalPart = fractionParts[1]
                ? Common_1.pad_(fractionParts[1], significanCount) + formatMatch[2] + "/" + formatMatch[3] + Common_1.rpad_(fractionParts[2], significanCount)
                // 对齐 google 的表现, 不需要补齐空格
                : '';
            // 历史逻辑: ?/? 场景对齐 excel 的表现, 补充尾部空格
            // : fill(' ', 2 * significanCount + 1 + formatMatch[2].length + formatMatch[3].length);
            // 完整分数表示
            return "" + wholeNumberPart + (fractionalPart ? ' ' : '') + fractionalPart;
        }
        if ((formatMatch = fmt.match(/^[#0?]+$/))) {
            o = "" + val;
            if (fmt.length <= o.length)
                return o;
            return hashq(fmt.substr(0, fmt.length - o.length)) + o;
        }
        if ((formatMatch = fmt.match(/^([#0]+)\.([#0]+)$/))) {
            o = "" + val.toFixed(Math.min(formatMatch[2].length, 10)).replace(/([^0])0+$/, '$1');
            significanCount = o.indexOf('.');
            var lres = fmt.indexOf('.') - significanCount;
            var rres = fmt.length - o.length - lres;
            return hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
        }
        if ((formatMatch = fmt.match(/^00,000\.([#0]*0)$/))) {
            return val < 0
                ? "-" + write_num_int(type, fmt, -val)
                : commaify("" + val)
                    .replace(/^\d,\d{3}$/, '0$&')
                    .replace(/^\d*$/, function ($$) { return "00," + ($$.length < 3 ? Common_1.pad0(0, 3 - $$.length) : '') + $$; }) + "." + Common_1.pad0(0, formatMatch[1].length);
        }
        switch (fmt) {
            case '###,###':
            case '##,###':
            case '#,###':
                var x = commaify("" + aval);
                return x !== '0' ? sign + x : '';
            default:
                if (fmt.match(/\.[0#?]*$/))
                    return write_num_int(type, fmt.slice(0, fmt.lastIndexOf('.')), val) + hashq(fmt.slice(fmt.lastIndexOf('.')));
        }
        return "" + val;
        // throw new Error("unsupported format |" + fmt + "|");
    }
    return function write_num(type, fmt, value) {
        var val = value;
        if (Common_1.isNumeric(value)) {
            val = parseFloat(value.toString());
            if (val === 0 &&
                value.toString() !== '0' &&
                !/0+[Ee]0+/.test(value.toString()) && // 排除 0E0
                !/0+(\.0+)?/.test(value.toString()) // 排除 0.0
            ) {
                // 数值太小，不能计算了  返回他的原始串吧
                return value.toString();
            }
            if (val === Infinity || val === -Infinity) {
                return value.toString();
            }
            if (val.toString() !== value.toString()) {
                // 若字符串长度超过 16 位 parsefloat 产生精度问题
                val = value.toString();
            }
        }
        else {
            return value.toString();
        }
        return (getNumericalVal(val) | 0) === val ? write_num_int(type, fmt, val) : write_num_flt(type, fmt, val);
    };
})();
var abstime = /\[[HhMmSs]*\]/;
// 根据内容和格式串执行内容格式化 输出最后显示的内容
// eslint-disable-next-line complexity, max-lines-per-function
// export function eval_fmt(fmt: string, v: any, opts: any, flen: number) {
//   let out: any[] = [];
//   let o = '';
//   let i = 0;
//   let c = '';
//   let lst = 't';
//   let dt: null | { H: number } = null;
//   let j;
//   let cc;
//   let q;
//   let hr = 'H';
//   /* Tokenize */
//   while (i < fmt.length) {
//     switch ((c = fmt.charAt(i))) {
//       case 'G' /* General */:
//         if (!isGeneral(fmt, i)) throw new Error(`unrecognized character ${c} in ${fmt}`);
//         out[out.length] = { t: 'G', v: 'General' };
//         i += 7;
//         break;
//       case '"' /* Literal text */:
//         for (o = ''; (cc = fmt.charCodeAt(++i)) !== 34 && i < fmt.length; ) o += String.fromCharCode(cc);
//         out[out.length] = { t: 't', v: o };
//         ++i;
//         break;
//       case '\\':
//         const w = fmt.charAt(++i);
//         const t = w === '(' || w === ')' ? w : 't';
//         out[out.length] = { t, v: w };
//         ++i;
//         break;
//       case '_':
//         out[out.length] = { t: 't', v: ' ' };
//         i += 2;
//         break;
//       case '@' /* Text Placeholder */:
//         out[out.length] = { t: 'T', v };
//         ++i;
//         break;
//       case 'B':
//       case 'b':
//         if (fmt.charAt(i + 1) === '1' || fmt.charAt(i + 1) === '2') {
//           if (dt === null) {
//             dt = parse_date_code(v, opts, fmt.charAt(i + 1) === '2');
//             if (dt == null) return [INVALID_VALUE, null];
//           }
//           out[out.length] = { t: 'X', v: fmt.substr(i, 2) };
//           lst = c;
//           i += 2;
//           break;
//         }
//       /* falls through */
//       case 'M':
//       case 'D':
//       case 'Y':
//       case 'H':
//       case 'S':
//       case 'E':
//         c = c.toLowerCase();
//       /* falls through */
//       case 'm':
//       case 'd':
//       case 'y':
//       case 'h':
//       case 's':
//       case 'e':
//       case 'g':
//         if (v < 0) return [INVALID_VALUE, null];
//         if (dt == null) {
//           dt = parse_date_code(v, opts);
//           if (dt == null) return [INVALID_VALUE, null];
//         }
//         o = c;
//         while (++i < fmt.length && fmt.charAt(i).toLowerCase() === c) o += c;
//         if (c === 'm' && lst.toLowerCase() === 'h' && o.length <= 2) c = 'M'; // m连续超过2个的话就只能识别成月份了
//         if (c === 'm' && lst.toLowerCase() === 's' && o.length <= 2) c = 'M'; // m连续超过2个的话就只能识别成月份了
//         if (c === 'h') c = hr;
//         out[out.length] = { t: c, v: o };
//         lst = c;
//         break;
//       case 'A':
//       case 'a':
//         q = { t: c, v: c };
//         if (dt == null) {
//           dt = parse_date_code(v, opts);
//           if (dt == null) return [INVALID_VALUE, null];
//         }
//         if (fmt.substr(i, 3).toUpperCase() === 'A/P') {
//           if (dt != null) q.v = dt.H >= 12 ? 'P' : 'A';
//           q.t = 'T';
//           hr = 'h';
//           i += 3;
//         } else if (fmt.substr(i, 5).toUpperCase() === 'AM/PM') {
//           if (dt != null) q.v = dt.H >= 12 ? 'PM' : 'AM';
//           q.t = 'T';
//           i += 5;
//           hr = 'h';
//         } else if (fmt.substr(i, 4) === 'aaaa') {
//           if (dt != null) {
//             q.t = 'a';
//             q.v = 'aaaa';
//             i += 4;
//           }
//         } else if (fmt.substr(i, 3) === 'aaa') {
//           if (dt != null) {
//             q.t = 'a';
//             q.v = 'aaa';
//             i += 3;
//           }
//         } else {
//           q.t = 't';
//           ++i;
//         }
//         out[out.length] = q;
//         lst = c;
//         break;
//       case '上':
//         q = { t: c, v: c };
//         if (dt === null) {
//           dt = parse_date_code(v, opts);
//           if (dt === null) return [INVALID_VALUE, null];
//         }
//         if (fmt.substr(i, 5).toUpperCase() === '上午/下午') {
//           if (dt != null) q.v = dt.H >= 12 ? '下午' : '上午';
//           q.t = 'T';
//           i += 5;
//           hr = 'h';
//         } else {
//           q.t = 't';
//           ++i;
//         }
//         out[out.length] = q;
//         lst = c;
//         break;
//       case '[':
//         o = c;
//         while (fmt.charAt(i++) !== ']' && i < fmt.length) o += fmt.charAt(i);
//         if (o.slice(-1) !== ']') throw `unterminated "[" block: |${o}|`;
//         if (o.match(abstime)) {
//           if (dt == null) {
//             dt = parse_date_code(v, opts);
//             if (dt == null) return [INVALID_VALUE, null];
//           }
//           out[out.length] = { t: 'Z', v: o.toLowerCase() };
//           lst = o.charAt(1);
//         } else if (o.toLowerCase() === '[$-f800]') {
//           // 处理[$-F800]
//           fmt = `${fmt.substr(0, i)}yyyy"年"m"月"d"日" aaaa`;
//           break;
//         } else if (o.toLowerCase() === '[$-f400]') {
//           // 处理[$-F400]
//           fmt = `${fmt.substr(0, i)}上午/下午 h:mm:ss`; // 对齐windows excel体验
//           break;
//         } else if (o.indexOf('$') > -1) {
//           o = (o.match(/\$([^-\[\]]*)/) || [])[1] || '$';
//           if (/\[\$\-\d+\].*a{3,4}/.test(fmt)) {
//             // 日期类型 星期x或者周x  暂时不支持国家，这个就忽略掉
//             break;
//           }
//           if (!fmtIsDate(fmt)) out[out.length] = { t: 't', v: o };
//         } else if (o.match(/DBNum\d+/)) {
//           let nextArg = '';
//           out[out.length] = { t: 'DN', v: o };
//           // 忽略后面的国家相关串
//           if (i < fmt.length && fmt.charAt(i++) === '[') {
//             while (fmt.charAt(i++) !== ']' && i < fmt.length) nextArg += fmt.charAt(i);
//             if (nextArg.slice(-1) !== ']') throw `unterminated "[" block: |${nextArg}|`;
//           }
//         } else if (isColorFormat(o)) {
//           out[out.length] = { t: 'Color', v: getColorByFormat(o) };
//         }
//         break;
//       /* Numbers */
//       case '.':
//         if (dt != null) {
//           o = c;
//           while (++i < fmt.length && (c = fmt.charAt(i)) === '0') o += c;
//           out[out.length] = { t: 's', v: o };
//           break;
//         }
//       /* falls through */
//       case '0':
//       case '#':
//         o = c;
//         while (
//           (++i < fmt.length && '0#?.,E+-%'.indexOf((c = fmt.charAt(i))) > -1) ||
//           (c == '\\' && fmt.charAt(i + 1) == '-' && i < fmt.length - 2 && '0#'.indexOf(fmt.charAt(i + 2)) > -1)
//         )
//           o += c;
//         out[out.length] = { t: 'n', v: o };
//         break;
//       case '?':
//         o = c;
//         while (fmt.charAt(++i) === c) o += c;
//         out[out.length] = { t: c, v: o };
//         lst = c;
//         break;
//       case '*':
//         // 由于渲染层还不支持两端对齐，所以没法做会计专用的识别
//         // if (i+1<fmt.length) {
//         //     var nextChar = fmt.charAt(i+1);
//         //     var str = '';
//         //     for (var index=0;index<3;index++) {//星号代表重复出现 因为现在不支持 所以先显示3个意思意思一下
//         //         str += nextChar;
//         //     }
//         //     out[out.length] = {t:'t', v:str};
//         // }
//         i += 2;
//         break; // **
//       case '(':
//       case ')':
//         out[out.length] = { t: flen === 1 ? 't' : c, v: c };
//         ++i;
//         break;
//       case '1':
//       case '2':
//       case '3':
//       case '4':
//       case '5':
//       case '6':
//       case '7':
//       case '8':
//       case '9':
//         o = c;
//         while (i < fmt.length && '0123456789'.indexOf(fmt.charAt(++i)) > -1) o += fmt.charAt(i);
//         out[out.length] = { t: 'D', v: o };
//         break;
//       case ' ':
//         out[out.length] = { t: c, v: c };
//         ++i;
//         break;
//       case '%':
//         out[out.length] = { t: 'n', v: c };
//         ++i;
//         break;
//       default:
//         if (",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(c) === -1) return v; // 直接返回算了
//         // throw new Error('unrecognized character ' + c + ' in ' + fmt);
//         out[out.length] = { t: 't', v: c };
//         ++i;
//         break;
//     }
//   }
//   let bt = 0;
//   let ss0 = 0;
//   let ssm;
//   for (i = out.length - 1, lst = 't'; i >= 0; --i) {
//     switch (out[i].t) {
//       case 'h':
//       case 'H':
//         out[i].t = hr;
//         lst = 'h';
//         if (bt < 1) bt = 1;
//         break;
//       case 's':
//         if ((ssm = out[i].v.match(/\.0+$/))) ss0 = Math.max(ss0, ssm[0].length - 1);
//         if (bt < 3) bt = 3;
//       /* falls through */
//       case 'd':
//       case 'y':
//       case 'M':
//       case 'e':
//         lst = out[i].t;
//         break;
//       case 'm':
//         if (lst === 's' && out[i].v.length <= 2 /* 时间最大只能两个m */) {
//           out[i].t = 'M';
//           if (bt < 2) bt = 2;
//         }
//         break;
//       case 'X' /* if(out[i].v === "B2"); */:
//         break;
//       case 'Z':
//         if (bt < 1 && out[i].v.match(/[Hh]/)) bt = 1;
//         if (bt < 2 && out[i].v.match(/[Mm]/)) bt = 2;
//         if (bt < 3 && out[i].v.match(/[Ss]/)) bt = 3;
//     }
//   }
//   // switch(bt) {
//   //     case 0: break;
//   //     case 1:
//   //         /*::if(!dt) break;*/
//   //         if(dt.u >= 0.5) { dt.u = 0; ++dt.S; }
//   //         if(dt.S >=  60) { dt.S = 0; ++dt.M; }
//   //         if(dt.M >=  60) { dt.M = 0; ++dt.H; }
//   //         break;
//   //     case 2:
//   //         /*::if(!dt) break;*/
//   //         if(dt.u >= 0.5) { dt.u = 0; ++dt.S; }
//   //         if(dt.S >=  60) { dt.S = 0; ++dt.M; }
//   //         break;
//   // }
//   // 星期x和周x要去掉前面的国家代码  暂时不支持
//   /* replace fields */
//   let nstr = '';
//   let jj;
//   let outputNumType = '0'; // 输出的数字样式  0为原始值  1为中文小写 2为中文大写
//   let colorFormat = undefined;
//   let needCutEndPercentageLabel = false;
//   for (i = 0; i < out.length; ++i) {
//     switch (out[i].t) {
//       case 't':
//       case 'T':
//       case ' ':
//       case 'D':
//         break;
//       case 'X':
//         out[i].v = '';
//         out[i].t = ';';
//         break;
//       case 'd':
//       case 'm':
//       case 'y':
//       case 'h':
//       case 'H':
//       case 'M':
//       case 's':
//       case 'e':
//       case 'b':
//       case 'Z':
//       case 'a':
//         /* : :if(!dt) throw "unreachable"; */
//         out[i].v = write_date(out[i].t.charCodeAt(0), out[i].v, dt, ss0);
//         out[i].t = 't';
//         break;
//       case 'n':
//       case '(':
//       case '?':
//         jj = i + 1;
//         if (out[i].t === 'n' && out[i].v === '%') {
//           nstr += out[i].v; // 填入数字计算格式串
//           out[i].t = 't'; // 然后就只要直接输出了
//           needCutEndPercentageLabel = true;
//           i = jj - 1;
//           break;
//         }
//         while (
//           out[jj] != null &&
//           ((c = out[jj].t) === '?' ||
//             c === 'D' ||
//             ((c === ' ' || c === 't') &&
//               out[jj + 1] != null &&
//               (out[jj + 1].t === '?' || (out[jj + 1].t === 't' && out[jj + 1].v === '/'))) ||
//             (out[i].t === '(' && (c === ' ' || c === 'n' || c === ')')) ||
//             (c === 't' && (out[jj].v === '/' || (out[jj].v === ' ' && out[jj + 1] != null && out[jj + 1].t == '?'))))
//         ) {
//           out[i].v += out[jj].v;
//           out[jj] = { v: '', t: ';' };
//           ++jj;
//         }
//         if (out[i].t === '(' && out[i].v === '(' && out[jj] != null && out[jj] !== 'n') {
//           i = jj - 1;
//           break; // 如果括号后面直接跟n 就放到nstr里面去处理  如果不是 就不放进去了
//         }
//         nstr += out[i].v;
//         i = jj - 1;
//         out[i].v = out[i].v.replace(/([0#\?]+),+$/, '$1'); // 去掉跟在数字后面的逗号占位符 逗号作用其二： 将数字按1000的倍数进行缩放。如果逗号跟在数字占位符的后面时，表示按1000的倍数进行缩放。一个逗号缩放1000，两个逗号缩放1000*1000倍。 例：如果格式为 "#.0," ，并在单元格中键入123456789，则会显示数字123456.8
//         break;
//       case 'G':
//         out[i].t = 't';
//         if (outputNumType) {
//           out[i].v = v;
//         } else {
//           out[i].v = general_fmt(v);
//         }
//         break;
//       case 'DN':
//         // 处理数字转中文
//         outputNumType = out[i].v.replace(/\[DBNum(\d)\]/, '$1');
//         break;
//       case 'Color':
//         colorFormat = out[i].v;
//         out[i].t = 't'; // 颜色解析完这个节点就可以废弃了
//         out[i].v = '';
//         break;
//     }
//   }
//   let vv = '';
//   let myv;
//   let ostr;
//   if (nstr.length > 0) {
//     if (nstr.charCodeAt(0) == 40) {
//       /* '(' */ myv = v < 0 && nstr.charCodeAt(0) === 45 ? positiveNumberOrString(v) : v;
//       ostr = write_num('(', nstr, myv);
//     } else {
//       myv = v < 0 && flen > 1 ? positiveNumberOrString(v) : v;
//       ostr = write_num('n', nstr, myv);
//       if (myv < 0 && out[0] && out[0].t == 't') {
//         ostr = ostr.substr(1);
//         out[0].v = `-${out[0].v}`;
//       }
//     }
//     if (needCutEndPercentageLabel && ostr && ostr.endsWith('%')) {
//       ostr = ostr.substr(0, ostr.length - 1); // 截掉末尾的百分比符号
//     }
//     jj = ostr.length - 1;
//     let decpt = out.length;
//     for (i = 0; i < out.length; ++i) {
//       if (out[i] != null && out[i].t != 't' && out[i].v && out[i].v.indexOf('.') > -1) {
//         decpt = i;
//         break;
//       }
//     }
//     let lasti = out.length;
//     if (decpt === out.length && ostr.indexOf('E') === -1) {
//       for (i = out.length - 1; i >= 0; --i) {
//         if (out[i] == null || 'n?('.indexOf(out[i].t) === -1) continue;
//         if (out[i].t === '(' && out[i].v === '(') {
//           out[i].t = 't';
//           continue;
//         }
//         if (jj >= out[i].v.length - 1) {
//           jj -= out[i].v.length;
//           out[i].v = ostr.substr(jj + 1, out[i].v.length);
//         } else if (jj < 0) {
//           if (out[i].t !== '(') {
//             out[i].v = '';
//           }
//         } else {
//           out[i].v = ostr.substr(0, jj + 1);
//           jj = -1;
//         }
//         out[i].t = 't';
//         lasti = i;
//       }
//       if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
//     } else if (decpt !== out.length && ostr.indexOf('E') === -1) {
//       jj = ostr.indexOf('.') - 1;
//       if (jj >= 0) {
//         // 如果小于0  这里需要特殊处理下
//         for (i = decpt; i >= 0; --i) {
//           if (out[i] == null || 'n?('.indexOf(out[i].t) === -1) continue;
//           j = out[i].v.indexOf('.') > -1 && i === decpt ? out[i].v.indexOf('.') - 1 : out[i].v.length - 1;
//           vv = out[i].v.substr(j + 1);
//           if (vv !== '') {
//             // 如果没有内容  就没必要进去操作j和jj了
//             for (; j >= 0 && jj >= 0; --j, --jj) {
//               if (out[i].v.charAt(j) === '0' || out[i].v.charAt(j) === '#' || out[i].v.charAt(j) === '?') {
//                 vv = ostr.charAt(jj) + vv;
//               } else if (out[i].v.charAt(j) === ostr.charAt(jj)) {
//                 vv = ostr.charAt(jj) + vv;
//               } else {
//                 jj++; // jj就不移动了
//               }
//             }
//           }
//           if (out[i].t === '(' && out[i].v === '(') {
//             out[i].t = 't';
//           } else {
//             out[i].v = vv;
//             out[i].t = 't';
//             lasti = i;
//           }
//         }
//         if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
//         jj = ostr.indexOf('.') + 1;
//         for (i = decpt; i < out.length; ++i) {
//           if (out[i] == null || ('n?('.indexOf(out[i].t) === -1 && i !== decpt)) continue;
//           j = out[i].v.indexOf('.') > -1 && i === decpt ? out[i].v.indexOf('.') + 1 : 0;
//           vv = out[i].v.substr(0, j);
//           for (; j < out[i].v.length; ++j) {
//             if (jj < ostr.length) {
//               const char = ostr.charAt(jj);
//               if (out[i].v.charAt(j) === '0' || out[i].v.charAt(j) === '#' || out[i].v.charAt(j) === '?') {
//                 vv += char;
//                 jj++;
//               } else {
//                 vv += out[i].v.charAt(j);
//                 jj++;
//                 break;
//               }
//             }
//           }
//           out[i].v = vv;
//           out[i].t = 't';
//           lasti = i;
//         }
//       } else {
//       }
//     }
//   }
//   if (outputNumType !== '0' && out.length >= 2 && out[0].t === 'DN') {
//     // 需要转换大小写
//     out = out.filter((o, index) => {
//       if (o.t === 't' && isNumeric(o.v)) {
//         let opts = undefined;
//         if (index + 1 < out.length) {
//           if (out[index + 1].v == '年') {
//             // 年份的转换不需要单位
//             opts = { unit: false, fill: true };
//           } else if (out[index + 1].v == '月' || out[index + 1].v == '日') {
//             opts = { unit: true, fill: true };
//           } else if (out[index + 1].v == '分') {
//             opts = { unit: true, fill: true };
//           } else if (out[index + 1].v == '时') {
//             opts = { unit: true, fill: false };
//           }
//         }
//         // 非以上情况的常规数字转化开启 showTenOne, 对齐 excel
//         opts = opts || { unit: true, fill: false, showTenOne: true }; // 赋个默认值
//         o.v = convertNumToChinese(o.v, outputNumType, opts);
//         return true;
//       }
//       if (o.t === 'DN') {
//         return false;
//       }
//       return true;
//     });
//   }
//   for (i = 0; i < out.length; ++i) {
//     if (out[i] != null && 'n?'.indexOf(out[i].t) > -1) {
//       myv = flen > 1 && v < 0 && i > 0 && out[i - 1].v === '-' ? positiveNumberOrString(v) : v;
//       out[i].v = write_num(out[i].t, out[i].v, myv);
//       out[i].t = 't';
//     }
//   }
//   let retval = '';
//   for (i = 0; i !== out.length; ++i) if (out[i] != null) retval += out[i].v;
//   return [retval, colorFormat];
//   // return [retval, undefined];//先不同步这个颜色出去 还没开发完
// }
// 格式化单元格内容
// export function format(fmt: string, v: number | string | boolean | null, o?: any) {
//   if (o == null) o = {};
//   if (isGeneral(fmt, 0)) return [general_fmt(v), undefined];
//   const f = choose_fmt(fmt, v);
//   if (isGeneral(f.fmt)) return [general_fmt(v), undefined];
//   if (v === '' || v == null || (typeof v === 'string' && v.trim() === '')) return ['', undefined];
//   if (typeof v === 'string' && !checkNumericValue(v) && (f.fmt === '@' || f.fmt.indexOf('@') === -1))
//     return [v, undefined]; //  内容是字符串  格式又不是特殊文本格式的时候 就可以直接返回了
//   return eval_fmt(f.fmt, v, o, f.length);
// }
function checkNumericValue(value) {
    var isValidNumericValue = false;
    if (Common_1.isNumeric(value)) {
        var val = parseFloat(value);
        if (val === 0 &&
            value.toString() !== '0' &&
            !/0+[Ee]0+/.test(value) && // 排除 0E0
            !/0+(\.0+)?/.test(value) // 排除 0.0
        ) {
            // 数值太小，不能计算了  返回他的原始串吧
            isValidNumericValue = false;
        }
        else if (val === Infinity || val === -Infinity) {
            isValidNumericValue = false;
        }
        else {
            return true;
        }
    }
    return isValidNumericValue;
}
exports.checkNumericValue = checkNumericValue;
/**
 * 转换数字为中文
 * @param {*} num 待转换的数字
 * @param {*} type 要转换的类型 目前只支持1中文小写 2中文大写
 * @param {*} opts 可选参数
 *            opts.fill 要不要补充前导0
 *            opts.unit是否按单位计算还是挨个换算  如果为false 1900 就翻译成一九○○  如果为true 则翻译成 一千九百
 *            opts.showTenOne  当数字开头是一十X兆/亿/万/十的时候要不要显示前面的一 默认隐藏
 */
function convertNumToChinese(num, type, opts) {
    // 将原始输入转为字符
    num = num.toString();
    // 转成中文大写
    var cnNums;
    var cnIntRadice;
    var cnIntUnits;
    // let cnInteger = "整"; //整数金额时后面跟的字符
    if (type === '1') {
        // 转成中文小写
        cnNums = ['〇', '一', '二', '三', '四', '五', '六', '七', '八', '九']; // 汉字的数字
        cnIntRadice = ['', '十', '百', '千']; // 基本单位
        cnIntUnits = ['', '万', '亿', '兆']; // 对应整数部分扩展单位
    }
    else if (type === '2') {
        // 转成中文大写
        cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']; // 汉字的数字
        cnIntRadice = ['', '拾', '佰', '仟']; // 基本单位
        cnIntUnits = ['', '万', '亿', '兆']; // 对应整数部分扩展单位
    }
    else {
        return "" + num;
    }
    var maxNum = 999999999999999.9999; // 最大处理的数字
    var IntegerNum; // 金额整数部分
    var DecimalNum; // 金额小数部分
    var ChineseStr = ''; // 输出的中文金额字符串
    var parts; // 分离金额后用的数组，预定义
    if (num === '') {
        return '';
    }
    var originLen = num.length;
    var n = parseFloat(num);
    if (n >= maxNum) {
        // TODO 超出最大数字，暂时直接返回原值，后面再改造
        return num;
    }
    num = n.toString(); // 转换为字符串
    if (originLen > num.length && opts && opts.fill) {
        // 如果字符转成中文之后又长度不相等  说明有前导0  要补齐
        var pollFillO = originLen - num.length;
        while (pollFillO-- > 0) {
            ChineseStr += cnNums[0];
        }
    }
    if (n === 0) {
        ChineseStr += cnNums[0];
        return ChineseStr;
    }
    if (n < 0) {
        ChineseStr += '-'; // 符号
        num = num.substr(1);
    }
    if (num.indexOf('.') === -1) {
        IntegerNum = num;
        // DecimalNum = '';
    }
    else {
        parts = num.split('.');
        IntegerNum = parts[0];
        DecimalNum = parts[1];
    }
    if (parseInt(IntegerNum, 10) > 0) {
        // 获取整型部分转换
        var zeroCount = 0;
        var IntLen = IntegerNum.length;
        for (var i = 0; i < IntLen; i++) {
            var n_1 = IntegerNum.substr(i, 1);
            var p = IntLen - i - 1;
            var q = p / 4;
            var m = p % 4;
            if (n_1 == '0') {
                if (opts && !opts.unit) {
                    // 如果没有单位的话  那就挨个取就可以了
                    ChineseStr += cnNums[parseInt(n_1)];
                }
                else {
                    zeroCount++;
                }
            }
            else {
                if (zeroCount > 0) {
                    ChineseStr += cnNums[0];
                }
                zeroCount = 0; // 归零
                if (i === 0 && n_1 === '1' && m === 1 && (!opts || !opts.showTenOne)) {
                    // 只针对第一个数字
                    // 一十就不需要显示一了  直接显示十
                }
                else {
                    ChineseStr += cnNums[parseInt(n_1)];
                }
                if (opts && opts.unit) {
                    ChineseStr += cnIntRadice[m];
                }
            }
            if (m == 0 && zeroCount < 4 && opts && opts.unit) {
                ChineseStr += cnIntUnits[q];
            }
        }
        // ChineseStr += cnIntLast;
        // 整型部分处理完毕
    }
    else {
        ChineseStr += cnNums[0];
    }
    if (DecimalNum && DecimalNum !== '' && Number(DecimalNum) !== 0) {
        // 小数部分
        var decLen = DecimalNum.length;
        if (decLen > 0) {
            ChineseStr += '.'; // 点号
        }
        for (var i = 0; i < decLen; i++) {
            var n_2 = DecimalNum.substr(i, 1);
            ChineseStr += cnNums[Number(n_2)];
        }
    }
    if (ChineseStr === '') {
        ChineseStr += cnNums[0];
    }
    return ChineseStr;
}
/** 判断是不是带颜色的格式 */
function isColorFormat(val) {
    var colorResult = val.match(/\[(.+)\]/);
    var color;
    if (colorResult) {
        color = colorResult[1];
    }
    else {
        return false;
    }
    var keys = Object.keys(Constant_1.COLOR_MAP);
    for (var i = 0; i < keys.length; i++) {
        if (keys[i] === color) {
            return true;
        }
    }
    return false;
}
exports.isColorFormat = isColorFormat;
/** 获取格式中的颜色值 */
function getColorByFormat(val) {
    var colorResult = val.match(/\[(.+)\]/);
    var color;
    if (colorResult) {
        color = colorResult[1];
        return Constant_1.COLOR_MAP[color];
    }
    return null;
}
exports.getColorByFormat = getColorByFormat;
function getDefaultNumberFormat() {
    return NumberFormatFactory_1.default.createInstance({
        id: 0,
        pattern: Constant_1.DEFAULT_FORMAT_PATTERN,
    });
}
exports.getDefaultNumberFormat = getDefaultNumberFormat;
function getNumberFormatNameByType(type) {
    if (type) {
        for (var i = 0; i < Constant_1.NUMBER_FORMAT_NAME.length; i += 1) {
            if (Constant_1.NUMBER_FORMAT_NAME[i].type === type) {
                return Constant_1.NUMBER_FORMAT_NAME[i].name;
            }
        }
    }
    return '常规';
}
exports.getNumberFormatNameByType = getNumberFormatNameByType;
function getFormatCodeByNumberFormat(numberFormat) {
    return numberFormat.pattern || getDefaultNumberFormat().toString(); // 如果找不到就按常规处理
}
exports.getFormatCodeByNumberFormat = getFormatCodeByNumberFormat;
/**
 * 判断格式串format是什么类型
 * @param {*} format
 */
function getFormatType(format) {
    var group = NumberFormatType_1.NUMBER_FORMAT_TYPE.GENERAL;
    var type = NumberFormatType_1.NUMBER_FORMAT_TYPE.GENERAL;
    var extraInfo;
    var out;
    if (format === '@' || (format.indexOf(';') === -1 && format.indexOf('@') !== -1)) {
        group = NumberFormatType_1.NUMBER_FORMAT_TYPE.TEXT;
        type = NumberFormatType_1.NUMBER_FORMAT_TYPE.TEXT;
    }
    else if (format === 'General') {
        group = NumberFormatType_1.NUMBER_FORMAT_TYPE.GENERAL;
        type = NumberFormatType_1.NUMBER_FORMAT_TYPE.GENERAL;
    }
    else if ((out = isExponentialCell(format))) {
        group = NumberFormatType_1.NUMBER_FORMAT_TYPE.SCIENTIFIC;
        type = 'exponential';
    }
    else if ((out = isPercentageCell(format))) {
        group = NumberFormatType_1.NUMBER_FORMAT_TYPE.PERCENT;
        type = NumberFormatType_1.NUMBER_FORMAT_TYPE.PERCENT;
    }
    else if ((out = isCurrencyCell(format))) {
        group = NumberFormatType_1.NUMBER_FORMAT_TYPE.CURRENCY;
        type = out;
    }
    else if ((out = isFractionFormat(format))) {
        group = NumberFormatType_1.NUMBER_FORMAT_TYPE.FRACTION;
        type = NumberFormatType_1.NUMBER_FORMAT_TYPE.FRACTION;
    }
    else if ((out = isDateTimeCell(format))) {
        var dateTimeType = getNumByDateType(out);
        type = dateTimeType || NumberFormatType_1.NUMBER_FORMAT_TYPE.DATE;
        group = type;
        type = exports.format2TypeMapping[format];
        if (!type) {
            // type = group; @fly
            type = NumberFormatType_1.NUMBER_FORMAT_TYPE.CUSTOM;
        }
        extraInfo = out;
    }
    else if ((out = isSpecialCell(format))) {
        group = NumberFormatType_1.NUMBER_FORMAT_TYPE.SPECIAL;
        type = NumberFormatType_1.NUMBER_FORMAT_TYPE.SPECIAL;
    }
    else if ((out = isNumberCell(format))) {
        group = NumberFormatType_1.NUMBER_FORMAT_TYPE.NUMBER;
        type = 'numeral'; // @fly 在组件中定义的value不一样其他地地方用的numeral
    }
    else if (format && format !== 'General') {
        group = NumberFormatType_1.NUMBER_FORMAT_TYPE.CUSTOM;
        type = NumberFormatType_1.NUMBER_FORMAT_TYPE.CUSTOM;
    }
    else {
        group = NumberFormatType_1.NUMBER_FORMAT_TYPE.GENERAL;
        type = NumberFormatType_1.NUMBER_FORMAT_TYPE.GENERAL;
    }
    return { group: group, type: type, extraInfo: extraInfo };
}
exports.getFormatType = getFormatType;
/**
 * 需要通过整个格式串来判断是不是内置的特殊格式串
 * @param formatCode
 */
function isBuildInSpecialFormat(formatCode) {
    // 判断是不是无符号货币
    if (/^#,##0(\.0+)?;\[Red\]-#,##0(\.0+)?$/.test(formatCode) ||
        /^#,##0(\.0+)?;\[红色\]-#,##0(\.0+)?$/.test(formatCode) ||
        /^#,##0(\.0+)?$/.test(formatCode)) {
        return {
            group: NumberFormatType_1.NUMBER_FORMAT_TYPE.CURRENCY,
            type: NumberFormatType_1.NUMBER_FORMAT_TYPE.CURRENCY,
        };
    }
}
exports.isBuildInSpecialFormat = isBuildInSpecialFormat;
/**
 * 去掉str串中的引号和引号内的内容
 * 同时去掉无意义的字符  包括下划线 反斜杠 星号 这三个字符出现的话  他后面的字符也要一起忽略
 * @param {string} str
 * @param {boolean} flag 是否要保留[]之间的内容 \*-后面的字符
 */
function clearQuotationMask(str, flag) {
    if (!str) {
        return '';
    }
    // 性能优化，改成一个for循环
    var i;
    var l;
    var c;
    var quotationFlag = false; // 遇到引号标记  引号内的内容无异议
    var bracketFlag = false; // 遇到符号[标记   []之间的内容大部分场景下无异议 除非flag为true的时候
    var resultStr = '';
    var bracketStr = '';
    for (i = 0, l = str.length; i < l; i += 1) {
        if (!quotationFlag) {
            c = str.charCodeAt(i);
            switch (c) {
                case 34: {
                    // "
                    quotationFlag = !quotationFlag;
                    break;
                }
                case 91: {
                    // [
                    bracketFlag = true;
                    break;
                }
                case 93: {
                    // ]
                    bracketFlag = false;
                    var isNeedRetain = flag; // 是否要保留[]内的字符串
                    // 判断[]内是不是颜色如果是的话就剔除  否则flag为true的情况下要保留
                    var keys = Object.keys(Constant_1.COLOR_MAP);
                    for (var i_1 = 0; i_1 < keys.length; i_1 += 1) {
                        if (keys[i_1] === bracketStr) {
                            // 是颜色 不保留
                            isNeedRetain = false;
                            break;
                        }
                    }
                    if (isNeedRetain) {
                        resultStr += "[" + bracketStr + "]";
                    }
                    bracketStr = '';
                    break;
                }
                case 95: {
                    // _
                }
                case 92: {
                    // \
                }
                case 42: {
                    // *
                    if (!bracketFlag) {
                        if (flag) {
                            resultStr += str[i];
                        }
                        else {
                            i += 1; // 跳过后面的字符
                        }
                    }
                    break;
                }
                default: {
                    if (!bracketFlag) {
                        resultStr += str[i];
                    }
                    else {
                        bracketStr += str[i];
                    }
                    break;
                }
            }
        }
        else if (str.charCodeAt(i) === 34) {
            // 遇到下一半引号了
            quotationFlag = !quotationFlag;
        }
    }
    return resultStr;
}
exports.clearQuotationMask = clearQuotationMask;
function isNumberCell(formatCode) {
    var realFormat = clearQuotationMask(formatCode); // 去掉引号内的部分内容 这些是不应该加入识别的
    if (formatCode === '_ * #,##0.00_ ' ||
        formatCode === '_ * "-"??_ ' ||
        formatCode === '_ * -#,##0.00_ ' ||
        formatCode === '_ @_ ') {
        // 千分位格式，用于会计专用
        return false;
    }
    if (/^[-]?[0#?,]+(\.[0#?]+)?(_ )?$/.test(realFormat) || /^\([0#?,]+(\.[0#?]+)?\)$/.test(realFormat)) {
        return true;
    }
    return false;
}
function isPercentageCell(formatCode) {
    var realFormat = clearQuotationMask(formatCode); // 去掉引号内的部分内容 这些是不应该加入识别的
    if (/%/.test(realFormat)) {
        return true;
    }
    return false;
}
function isExponentialCell(formatCode) {
    var realFormat = clearQuotationMask(formatCode); // 去掉引号内的部分内容 这些是不应该加入识别的
    if (/[0#?]+(\.[0#?]?)?[Ee][+-]?[0#?]+/.test(realFormat)) {
        // 例如0.E+00 0.00E+00
        return true;
    }
    return false;
}
function isCurrencyCell(formatCode) {
    Constant_1.SUPPORT_CURRENCY_LIST.sort(function (a, b) { return b.symbol.length - a.symbol.length; });
    var realFormat = clearQuotationMask(formatCode, true);
    var regResult = realFormat.match(/\[\$(.+)-(.+)\]/); // 匹配货币符号和地区编号
    if (regResult) {
        // 通过[$HK$-zh-CN] 这种方式表示货币
        // 判断去掉时区地区标记部分后剩下的部分是不是数值表示 如果是的话才是货币
        if (isNumberCell(realFormat.replace(/(\[\$.+-.+\])/, ''))) {
            var s = regResult[1]; // 匹配出来的货币符号
            var region = regResult[2]; // 地区展示没有用到
            for (var i = 0; i < Constant_1.SUPPORT_CURRENCY_LIST.length; i += 1) {
                if (s === Constant_1.SUPPORT_CURRENCY_LIST[i].symbol) {
                    // 命中了货币符号
                    return Constant_1.SUPPORT_CURRENCY_LIST[i].type;
                }
            }
        }
    }
    else {
        // 直接在格式串或者引号内表示货币
        realFormat = realFormat.replace(/\[.*\]/, '');
        for (var i = 0; i < Constant_1.SUPPORT_CURRENCY_LIST.length; i += 1) {
            if (realFormat.indexOf(Constant_1.SUPPORT_CURRENCY_LIST[i].symbol) !== -1 || // 去掉引号之后直接命中sybol
                formatCode.indexOf("\"" + Constant_1.SUPPORT_CURRENCY_LIST[i].symbol + "\"") !==
                    -1 /* 对没有去掉引号的看能否直接命中双引号内只有symbol的符号  如"US$"这种格式 */) {
                return Constant_1.SUPPORT_CURRENCY_LIST[i].type;
            }
        }
    }
}
/**
 * 是否是特殊类格式   邮编和中文大小写
 * @param {*} formatCode
 */
function isSpecialCell(formatCode) {
    return (formatCode === '000000' || // 邮编
        formatCode === '[DBNum1][$-804]General' || // 中文小写
        formatCode === '[DBNum2][$-804]General'); // 中文大写
}
function isDateTimeCell(formatCode) {
    var realFormat = clearQuotationMask(formatCode); // 去掉引号内的部分内容 这些是不应该加入识别的
    realFormat = realFormat.replace(/\[.*\]/, ''); // 去掉地区相关的信息先 里面可能有H 比如HK$ 这种 会错误识别为时间
    var out = {
        year: false,
        month: false,
        day: false,
        hour: false,
        minute: false,
        second: false,
        week: false,
    };
    var isDateTime = false;
    if (/[y|Y]/.test(realFormat)) {
        // 年
        out.year = true;
        isDateTime = true;
    }
    if (/[mM]/.test(realFormat)) {
        // 月
        var tempStr = realFormat.replace(/[\s:]/g, ''); // 去掉空格和冒号
        tempStr = tempStr.replace(/AM|PM|am|PM/g, ''); // 去掉上午和下午
        tempStr = tempStr.replace(/m+/g, 'm'); // 去掉连续的m
        if (/[^hHsS][mM][^hHsS]|[^hHsS][mM]$|^[mM][^hHsS]|^[mM]$/.test(tempStr)) {
            out.month = true;
            isDateTime = true;
        }
    }
    if (/[d|D]/.test(realFormat)) {
        // 日
        out.day = true;
        isDateTime = true;
    }
    if (/[h|H]/.test(realFormat)) {
        // 时
        out.hour = true;
        isDateTime = true;
    }
    if (/([hHsS]+(:|\s|(".*"))*[mM])|([mM](:|\s|(".*"))*[hHsS]+)/.test(realFormat)) {
        // 分
        out.minute = true;
        isDateTime = true;
    }
    if (/[s|S]/.test(realFormat)) {
        // 秒
        out.second = true;
        isDateTime = true;
    }
    if (/a{3,4}/.test(realFormat)) {
        // 星期x 或者周x
        out.week = true;
        isDateTime = true;
    }
    if (isDateTime) {
        return out;
    }
}
exports.isDateTimeCell = isDateTimeCell;
function isGeneralCell(numberFormat) {
    return !numberFormat || numberFormat.id === undefined || numberFormat.id === 0; /** 新的format没有或者为常规 */
}
exports.isGeneralCell = isGeneralCell;
function isGeneralCell2(numberFormat) {
    return !numberFormat || numberFormat.pattern === 'General'; /** 新的format没有或者为常规 */
}
exports.isGeneralCell2 = isGeneralCell2;
function isTextCell(numberFormat) {
    if (numberFormat) {
        var formatCode = getFormatCodeByNumberFormat(numberFormat);
        if (formatCode === '@' || (formatCode.indexOf(';') === -1 && formatCode.indexOf('@') !== -1)) {
            return true;
        }
    }
    return false;
}
exports.isTextCell = isTextCell;
/** 是否是分数数字格式 */
function isFractionFormat(formatCode) {
    var realFormat = clearQuotationMask(formatCode); // 去掉引号内的部分内容 这些是不应该加入识别的
    if (realFormat && /[0#]*\s*\?+\/([\d]+|[\?]+)/.test(realFormat.trim())) {
        return true;
    }
    return false;
}
exports.isFractionFormat = isFractionFormat;
function isDateCell(value, numberFormat) {
    if (!numberFormat) {
        return false;
    }
    var formatCode = getFormatCodeByNumberFormat(numberFormat);
    var f = Common_1.choose_fmt(formatCode, value);
    if (Common_1.fmtIsDate(f.fmt)) {
        return true;
    }
    return false;
}
exports.isDateCell = isDateCell;
// 年月日时分秒星期的位
var BIT_YEAR = 1 << 6;
var BIT_MONTH = 1 << 5;
var BIT_DAY = 1 << 4;
var BIT_HOUR = 1 << 3;
var BIT_MINUTE = 1 << 2;
var BIT_SECOND = 1 << 1;
var BIT_WEEK = 1 << 0;
var DATE_TIME_TYPE_MAP = [
    { key: BIT_YEAR | BIT_MONTH | BIT_DAY, type: NumberFormatType_1.NUMBER_FORMAT_TYPE.DATE },
    { key: BIT_YEAR | BIT_MONTH, type: NumberFormatType_1.NUMBER_FORMAT_TYPE.DATE },
    { key: BIT_MONTH | BIT_DAY, type: NumberFormatType_1.NUMBER_FORMAT_TYPE.DATE },
    { key: BIT_YEAR | BIT_DAY, type: NumberFormatType_1.NUMBER_FORMAT_TYPE.DATE },
    { key: BIT_YEAR, type: NumberFormatType_1.NUMBER_FORMAT_TYPE.DATE },
    { key: BIT_MONTH, type: NumberFormatType_1.NUMBER_FORMAT_TYPE.DATE },
    { key: BIT_DAY, type: NumberFormatType_1.NUMBER_FORMAT_TYPE.DATE },
    {
        key: BIT_YEAR | BIT_MONTH | BIT_DAY | BIT_HOUR | BIT_MINUTE,
        type: NumberFormatType_1.NUMBER_FORMAT_TYPE.DATE_TIME,
    },
    {
        key: BIT_YEAR | BIT_MONTH | BIT_DAY | BIT_HOUR | BIT_MINUTE | BIT_SECOND,
        type: NumberFormatType_1.NUMBER_FORMAT_TYPE.DATE_TIME,
    },
    { key: BIT_HOUR | BIT_MINUTE | BIT_SECOND, type: NumberFormatType_1.NUMBER_FORMAT_TYPE.TIME },
    { key: BIT_HOUR | BIT_MINUTE, type: NumberFormatType_1.NUMBER_FORMAT_TYPE.TIME },
    { key: BIT_MINUTE | BIT_SECOND, type: NumberFormatType_1.NUMBER_FORMAT_TYPE.TIME },
    { key: BIT_HOUR | BIT_SECOND, type: NumberFormatType_1.NUMBER_FORMAT_TYPE.TIME },
    { key: BIT_HOUR, type: NumberFormatType_1.NUMBER_FORMAT_TYPE.TIME },
    { key: BIT_SECOND, type: NumberFormatType_1.NUMBER_FORMAT_TYPE.TIME },
    { key: BIT_MINUTE, type: NumberFormatType_1.NUMBER_FORMAT_TYPE.TIME },
];
function getNumByDateType(info) {
    var result = 0;
    if (info) {
        info.year && (result = result | BIT_YEAR);
        info.month && (result = result | BIT_MONTH);
        info.day && (result = result | BIT_DAY);
        info.hour && (result = result | BIT_HOUR);
        info.minute && (result = result | BIT_MINUTE);
        info.second && (result = result | BIT_SECOND);
        info.week && (result = result | BIT_WEEK);
    }
    for (var i = 0; i < DATE_TIME_TYPE_MAP.length; i += 1) {
        if (DATE_TIME_TYPE_MAP[i].key === result) {
            return DATE_TIME_TYPE_MAP[i].type;
        }
    }
}
var uaIsMobile = (function () {
    var _a;
    var ua = ((_a = global.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) || '';
    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    var isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
    var isAndroid = ua.match(/(Android)\s+([\d.]+)/);
    return !!(isIphone || isAndroid);
})();
// 微软office 数字格式映射
// 这里是控制：手动设置单元格格式的时候，选择的格式串，要跟输入自动识别的格式串区分开
// pc端比移动端少了一些格式串
exports.txSheetToMsoFormatMapping = uaIsMobile
    ? {
        // default: '',//常规 无需映射
        auto: 'General',
        default: 'General',
        text: '@',
        numeral: '#,##0.00_ ',
        percentage: '0.00%',
        'percentage-int': '0%',
        exponential: '0.00E+00',
        // 'currency-none': '#,##0.00;-#,##0.00', //无符号货币
        'currency-chs': '"¥"#,##0.00_);[Red]\\("¥"#,##0.00\\)',
        'currency-hk': '[$HK$-C04]#,##0.00_);[Red]\\([$HK$-C04]#,##0.00\\)',
        'currency-en': '\\$#,##0.00_);[Red]\\(\\$#,##0.00\\)',
        time: 'h:mm:ss;@',
        'date-time': 'yyyy/m/d h:mm:ss;@',
        date: 'yyyy/m/d',
        'date-chs': 'yyyy"年"m"月"d"日";@',
        'date-chs-ym': 'yyyy"年"m"月";@',
        'date-chs-md': 'm"月"d"日";@',
        fraction: '# ?/?',
        m_d_yy: 'm/d/yy;@',
        'mmm-yy': '[$-409]mmm-yy;@',
        m_d: 'm/d;@',
        'yyyy-mm-dd': 'yyyy-mm-dd;@',
        yyyy_mm_dd: 'yyyy/mm/dd;@',
        'yyyy_m_d-h-m': 'yyyy/m/d h:mm;@',
        'h-mm': 'h:mm;@',
        yy_m_d: 'yy/m/d;@',
        'h-mm-ss-am_pm': '[$-409]h:mm:ss\\ AM/PM;@',
    }
    : {
        // default: '',//常规 无需映射
        default: 'General',
        auto: 'General',
        text: '@',
        numeral: '#,##0.00_ ',
        percentage: '0.00%',
        'percentage-int': '0%',
        exponential: '0.00E+00',
        currency: '#,##0.00',
        'currency-chs': '"¥"#,##0.00_);[Red]\\("¥"#,##0.00\\)',
        'currency-hk': '[$HK$-C04]#,##0.00_);[Red]\\([$HK$-C04]#,##0.00\\)',
        'currency-en': '\\$#,##0.00_);[Red]\\(\\$#,##0.00\\)',
        // 'currency-none': '#,##0.00;-#,##0.00', //无符号货币
        time: 'h:mm:ss;@',
        'date-time': 'yyyy/m/d h:mm:ss',
        date: 'yyyy/m/d',
        accounting: '_ * #,##0.00_ ;_ * -#,##0.00_ ;_ * "-"??_ ;_ @_',
        'date-chs': 'yyyy"年"m"月"d"日";@',
        'date-chs-ym': 'yyyy"年"m"月";@',
        'date-chs-md': 'm"月"d"日";@',
        fraction: '# ?/?',
    };
exports.format2TypeMapping = Common_1.invertObject(exports.txSheetToMsoFormatMapping);
/**
 * 获取单元格样式type  会真正解析样式格式
 * @param {*} numberFormat
 */
function getCellNumberFormatType(numberFormat) {
    if (numberFormat === null || numberFormat === undefined) {
        return {
            group: NumberFormatType_1.NUMBER_FORMAT_TYPE.GENERAL,
            type: NumberFormatType_1.NUMBER_FORMAT_TYPE.GENERAL,
        };
    }
    var formatCode;
    if (typeof numberFormat === 'string') {
        // 转换下类型
        formatCode = numberFormat;
    }
    else {
        if (numberFormat === undefined) {
            numberFormat = getDefaultNumberFormat();
        }
        formatCode = getFormatCodeByNumberFormat(numberFormat);
    }
    var resultType = FormatCache_1.default.get(formatCode);
    if (resultType) {
        // 如果之前识别过这个格式 那就直接用识别后的结果
        return resultType;
    }
    var fmtList = formatCode.split(';');
    if (fmtList.length > 4) {
        // 大于4段  已经不正常了   就直接返回自定义吧
        resultType = {
            group: NumberFormatType_1.NUMBER_FORMAT_TYPE.CUSTOM,
            type: NumberFormatType_1.NUMBER_FORMAT_TYPE.CUSTOM,
        };
    }
    else if ((resultType = isBuildInSpecialFormat(formatCode))) {
        // 判断是不是内置的一些特殊格式 直接用整个串来对比
    }
    else {
        var hasLastTextGroup = false; // 是否有最后一个文本格式串
        var lastPartFmt = fmtList[fmtList.length - 1];
        lastPartFmt = clearQuotationMask(lastPartFmt); // 去掉无效字符看一下
        if (fmtList.length === 2 && fmtList[1] === '@') {
            // @flyfuwang  临时加的，fmt变量已经把@去掉了，导致getFormatType里面比较不匹配, 这里做个特殊判断当yyyy-mm-dd;@ 这种结尾格式的，匹配会失败。free有空看下这里。
            fmtList = [];
            fmtList[0] = formatCode;
        }
        else if (lastPartFmt === '@') {
            // 如果最后一个是纯@符号  那就不参与解析评估了。   0.00;@这种还是要识别为数值的。
            fmtList = fmtList.slice(0, fmtList.length - 1);
            hasLastTextGroup = true;
        }
        // 获取每个分段格式的解析结果
        var resultList = fmtList.map(function (fmt) { return getFormatType(fmt); });
        // check每个分段格式的解析结果类型是否一致  如果不一致  要输出自定义
        var group = void 0;
        var type = void 0;
        var isCodeFormat = false;
        for (var i = resultList.length - 1; i >= 0; i--) {
            if (!type) {
                group = resultList[i].group;
                type = resultList[i].type;
            }
            else if (type !== resultList[i].type) {
                // 和前面的分段格式类型不一致，gg 返回自定义
                isCodeFormat = true;
                break;
            }
        }
        // 兼容下没有的场景
        group = group || (hasLastTextGroup ? NumberFormatType_1.NUMBER_FORMAT_TYPE.TEXT : NumberFormatType_1.NUMBER_FORMAT_TYPE.GENERAL);
        type = type || (hasLastTextGroup ? NumberFormatType_1.NUMBER_FORMAT_TYPE.TEXT : NumberFormatType_1.NUMBER_FORMAT_TYPE.GENERAL);
        if (isCodeFormat) {
            resultType = {
                group: NumberFormatType_1.NUMBER_FORMAT_TYPE.CUSTOM,
                type: NumberFormatType_1.NUMBER_FORMAT_TYPE.CUSTOM,
            };
        }
        else {
            resultType = { group: group, type: type }; // 这样的话用的是第一个有效分组（排除@）的结果，其实最好还是根据value去选择一波更合理
        }
    }
    FormatCache_1.default.put(formatCode, resultType); // 放入识别缓存
    return resultType;
}
exports.getCellNumberFormatType = getCellNumberFormatType;
function getNumberFormatByFormatCode(formatCode) {
    // 有可能出现 formatData 不是格式串而是格式类别(text, numeral...)的情况，这里做一下兼容处理
    // 确保一定是数据格式串
    formatCode = exports.txSheetToMsoFormatMapping[formatCode || 'General'] || formatCode || 'General';
    var numberFormat = NumberFormatFactory_1.default.createInstance({ pattern: formatCode });
    return numberFormat;
}
exports.getNumberFormatByFormatCode = getNumberFormatByFormatCode;
function increaseDecimalFormat(data, formatCode) {
    if (isFractionFormat(formatCode)) {
        // 对齐excel，如果原格式为分数格式串，增加小数位，则不改变其格式串
        return formatCode;
    }
    if (formatCode === 'General' || !formatCode) {
        if (data === '' || data === null || data === undefined || isNaN(data)) {
            // 数据为空或者不是数字而且原来就就是常规的话  那就不处理了  数据为空但是不为常规的话 还是要看能不能增加小数位的 excel是这么做的
            formatCode = 'General';
        }
        else {
            var numStr = data.toString();
            var regResult = numStr.match(/^[-]?(\d+)(.(\d+))?([e|E][-+]\d+)?$/);
            var decimalLen = regResult ? (regResult[3] !== undefined ? regResult[3].length : 0) : 0; // 计算数值中当前的小数位数作为初始的小数位
            var intNumLen = regResult ? regResult[1].length : 1; // 整数部分的长度
            if (intNumLen >= 12) {
                // 常规下大于等于12位的话会按科学计数展示  默认五位小数 所以这里要改成六位小数的科学计数
                formatCode = '0.000000E+00';
            }
            else {
                decimalLen = Math.min(10 - intNumLen, decimalLen); // 常规下默认只显示十位数字
                decimalLen = Math.max(0, decimalLen); // 如果小于0 那就取0
                if (decimalLen === 0) {
                    formatCode = '0.0_ '; // 数值格式串的第四种格式，excel中为自定义格式
                }
                else {
                    formatCode = "0." + Common_1.fill('0', decimalLen + 1) + "_ ";
                }
            }
        }
    }
    else {
        var newFormatCode = modifyFormat(formatCode, /((\]|^)[^\[]*)([0#,.?]+)(E\+[0#,.?]+)?/g, function (s) {
            // 不匹配 中文港币：[$HK$-C04] 英文港币：[$HK$-3C09]中中括号中的0
            if (s.indexOf('E+') !== -1) {
                if (s.indexOf('.') === -1) {
                    s = s.replace(/([0#?]+)(?=E\+)/g, '$1.0');
                }
                else {
                    s = s.replace(/(\.[0#?]+)E/g, '$10E');
                }
            }
            else if (s.indexOf('.') === -1) {
                s = s.replace(/([0#,?]+)/g, '$1.0');
            }
            else {
                s = s.replace(/(\.[0#?]+)/g, '$10');
            }
            return s;
        });
        // 检查是否超过了127位 最大不能超过127 否则返回原始串
        var dotLength = getCurrentCellDotNum(newFormatCode);
        if (dotLength <= 127) {
            formatCode = newFormatCode;
        }
    }
    if (!formatCode || formatCode.length === 0) {
        formatCode = 'General';
    }
    return formatCode;
}
exports.increaseDecimalFormat = increaseDecimalFormat;
function decreaseDecimalFormat(data, formatCode) {
    function decreaseFun(m) {
        if (m.indexOf('.') === -1) {
            m = m;
        }
        else if (m.indexOf('.') >= m.length - 2) {
            m = m.slice(0, m.indexOf('.'));
        }
        else if (/(\.[0#?])(?![0#?])/g.test(m)) {
            m = m.replace(/(\.[0#?])([^0#?]*)/g, '$2');
        }
        else {
            m = m.replace(/(\.[0#?]+?)/g, '.');
        }
        return m;
    }
    if (isFractionFormat(formatCode)) {
        // 对齐excel，如果原格式为分数格式串，减少小数位，则不改变其格式串
        return formatCode;
    }
    if (formatCode === 'General' || !formatCode) {
        if (data === '' || data === null || data === undefined || isNaN(data)) {
            // 数据为空或者不是数字而且原来就就是常规的话  那就不处理了  数据为空但是不为常规的话 还是要看能不能增加小数位的 excel是这么做的
            formatCode = 'General';
        }
        else {
            var numStr = data.toString();
            var regResult = numStr.match(/^[-]?(\d+)(.(\d+))?([e|E][-+]\d+)?$/);
            // 计算数值中当前的小数位数作为初始的小数位
            var decimalLen = regResult ? (regResult[3] !== undefined ? regResult[3].length : 0) : 0;
            var intNumLen = regResult ? regResult[1].length : 1; // 整数部分的长度
            if (intNumLen >= 12) {
                // 常规下大于等于12位的话会按科学计数展示  默认五位小数 所以这里要改成四位小数的科学计数
                formatCode = '0.0000E+00';
            }
            else {
                decimalLen = Math.min(10 - intNumLen, decimalLen); // 常规下默认只显示十位数字
                decimalLen = Math.max(0, decimalLen); // 如果小于0 那就取0
                if (decimalLen <= 1) {
                    formatCode = '0_ '; // 数值格式串的第四种格式，excel中为自定义格式
                }
                else {
                    formatCode = "0." + Common_1.fill('0', decimalLen - 1) + "_ ";
                }
            }
        }
    }
    else {
        formatCode = modifyFormat(formatCode, /((\]|^)[^\[]*)([0#,.?]+)(E\+[0#,.?]+)?/g, function (s) {
            // 不匹配 中文港币：[$HK$-C04] 英文港币：[$HK$-3C09]中中括号中的0
            if (s.indexOf('E+') !== -1) {
                if (s.indexOf('.') === -1) {
                    s = s;
                }
                else {
                    s = s.replace(new RegExp('\\.[0#?]*', 'g'), decreaseFun);
                }
            }
            else {
                s = decreaseFun(s);
            }
            if (s === '') {
                s = '#';
            }
            return s;
        });
    }
    if (!formatCode || formatCode.length === 0) {
        formatCode = 'General';
    }
    return formatCode;
}
exports.decreaseDecimalFormat = decreaseDecimalFormat;
/**
 * 修改格式串
 * @param {*} v 内容串  等待被修改的字符串
 * @param {*} reg  匹配正则
 * @param {*} r 替换串  可以是字符串也可以是方法
 */
function modifyFormat(v, reg, r) {
    var replaceFmt = function (v, reg, r) {
        var result = '';
        v.split('"').forEach(function (s, index) {
            // 双引号内的格式串不能进行格式替换
            if (index % 2 === 0) {
                s = s.replace(reg, r);
            }
            if (index > 0) {
                s = "\"" + s;
            }
            result += s;
        });
        return result;
    };
    var newFmtArray = [];
    if (v) {
        newFmtArray = v.split(';').map(function (s, index) {
            // 第三段字符串若含有?则不能进行格式替换。第四段格式串不存在的字符[#0?.]
            return index === 2 && s.indexOf('?') !== -1 ? s : replaceFmt(s, reg, r);
        });
    }
    return newFmtArray.join(';');
}
exports.modifyFormat = modifyFormat;
/**
 * 获取当前单元格的小数位数（没有的话返回默认值 当前默认值为0）
 * @param {*} formatCode
 */
function getCurrentCellDotNum(formatCode) {
    formatCode = formatCode || '';
    var fmt = formatCode.split(';')[0]; // 获取用来计算的格式串。  对齐excel，不管有几个部分  直接取第一个部分  以第一个部分为准
    fmt = clearQuotationMask(fmt); // 去掉引号内的部分内容 这些是不应该加入识别的
    fmt = fmt.toUpperCase();
    var eIndex = fmt.indexOf('E');
    var dotLen = 0; // 默认值
    if (eIndex !== -1) {
        // 科学计数表示  先去掉科学计数
        fmt = fmt.substr(0, eIndex);
    }
    var regResult = fmt.match(/([0#?,]*)[.]([0#?]+)?/);
    if (regResult) {
        dotLen = regResult[2] ? regResult[2].length : dotLen; // 如果有就取其长度 没有就用默认值
    }
    return dotLen;
}
exports.getCurrentCellDotNum = getCurrentCellDotNum;
function getNumberFormatByOldFormat(format) {
    var pattern;
    if (!format) {
        pattern = 'General';
    }
    else {
        pattern = exports.txSheetToMsoFormatMapping[format] || 'General';
    }
    return NumberFormatFactory_1.default.createInstance({ pattern: pattern });
}
exports.getNumberFormatByOldFormat = getNumberFormatByOldFormat;
function getCurrencySymbol(formatCode) {
    Constant_1.SUPPORT_CURRENCY_LIST.sort(function (a, b) { return b.symbol.length - a.symbol.length; });
    var realFormat = clearQuotationMask(formatCode, true);
    var regResult = realFormat.match(/\[\$(.+)-(.+)\]/); // 匹配货币符号和地区编号
    var symbol;
    if (regResult) {
        // 通过[$HK$-zh-CN] 这种方式表示货币
        // 判断去掉时区地区标记部分后剩下的部分是不是数值表示 如果是的话才是货币
        if (isNumberCell(realFormat.replace(/(\[\$.+-.+\])/, ''))) {
            symbol = regResult[1]; // 匹配出来的货币符号
        }
    }
    else {
        // 直接在格式串或者引号内表示货币
        realFormat = realFormat.replace(/\[.*\]/, '');
        for (var i = 0; i < Constant_1.SUPPORT_CURRENCY_LIST.length; i += 1) {
            if (realFormat.indexOf(Constant_1.SUPPORT_CURRENCY_LIST[i].symbol) !== -1 || // 去掉引号之后直接命中sybol
                formatCode.indexOf("\"" + Constant_1.SUPPORT_CURRENCY_LIST[i].symbol + "\"") !==
                    -1 /* 对没有去掉引号的看能否直接命中双引号内只有symbol的符号  如"US$"这种格式 */) {
                symbol = Constant_1.SUPPORT_CURRENCY_LIST[i].symbol;
            }
        }
    }
    return symbol;
}
exports.getCurrencySymbol = getCurrencySymbol;
//# sourceMappingURL=FormatUtils.js.map